import {
  EditOutlined,
  CaretRightOutlined,
  RightOutlined,
  PrinterOutlined,
  EyeOutlined,
  CheckCircleTwoTone,
  PlusOutlined,
  ExclamationCircleFilled,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Collapse,
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Alert,
  notification,
  Typography,
  Space,
  Spin,
  Card,
  Avatar,
  Descriptions,
  Modal,
  Result,
  Statistic,
  Divider,
  Table,
  Popconfirm,
  message,
} from "antd";

import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import memberService from "../../api/member.service";
import ProgrammeCommercialService from "../../api/programme.commercial.service";
import ProgrammeService from "../../api/programme.service";

import timeSlotService from "../../api/time.slot.service";

import {
  DATE_FORMAT_DMY_SLASH,
  MEMBER_ACCOUNT_ID,
  ROUND_OFF_ACCOUNT_ID,
  SAVE_SUCCESS_MSG,
  SUCCESS_STATUS,
  UPDATE_SUCCESS_MSG,
  BANK_CHARGES_ACCOUNT_ID,
  EDIT_MODE,
  PAYMENT_SECTION_REQUIRED_MESSAGE,
  ADD_ONE_PAYMENT_MODE,
  TAP_BOOKING_CREDIT_ACCOUNT_ID,
  TAP_BOOKING_SPECIAL_COACHING_CREDIT_ACCOUNT_ID,
} from "../../utility/Constants";

import TimeSlotEnrollment from "../enrollment/TimeSlotEnrollment";
import moment from "moment";
import enrollmentService from "../../api/enrollment.service";
import commonUtility from "../../utility/Utils";
import EnrollmentComponent from "../enrollment/commercial-components/EnrollmentComponent";
import accountService from "../../api/account.service";
import OtherItems from "../enrollment/commercial-components/OtherItems";
import TestFormItem from "../enrollment/commercial-components/TestFormItem";
import PaymentComponent from "../enrollment/commercial-components/PaymentComponent";
import paymentService from "../../api/payment.service";
import StudentCardInfo from "../common/StudentCardInfo";
import { useSelector } from "react-redux";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";
import TapTimeSlotView from "./TapTimeSlotView";
import commonService from "../../api/common.service";
import coachService from "../../api/coach.service";
import TapBookingGeneratedSchedule from "./TapBookingGeneratedSchedule";
import TapMemberAdjustment from "./TapMemberAdjustment";
import { PRINT_BASE_URL } from "../../utility/URL";
import { TRY_AGAIN_ERROR } from "../../utility/Constants";
import { TIME_SLOT_REQUIRED } from "../../utility/Constants";
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const { confirm } = Modal;

const styles = {
  requiredText: {
    color: "#f00",
  },
};

// Default Form Values
const defaultFormValues = {
  mode: "ADD",
  enrollment_id: 0,
  member_id: 0,
  programme_id: 0,

  voucher_id: 0,
  date_of_join: null,
  enrollment_start_date: null,
  enrollment_end_date: null,
  cr_ac_id: 0,
  is_waiver: "N",
  student_account_id: MEMBER_ACCOUNT_ID,
  member_opening_balance: 0,
  receipt_id: 0,
  receipt_no: "",
  receipt_date: null,
  is_payment_done: "N",
  no_of_months: 0,
  entry_from: "B", //B = Booking
  round_off_amount: 0,
  round_off_account_id: ROUND_OFF_ACCOUNT_ID,
  total_bank_charges: 0,
  bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
  taxable_amount: 0,
  cgst_id: "",
  cgst_rate: 0,
  cgst_amount: 0,
  sgst_id: "",
  sgst_rate: 0,
  sgst_amount: 0,
  total_gst_amount: 0,
  payment_id: 0,
  total_schedule_amount: 0,
  from_date: "",
  to_date: "",
  tap_group: "",
  is_with_coach: "",
  coach_master_id: "",
  rate_per_slot: 0,
  less_adjustment_days: 0,
  less_adjustment_rate: 0,
  discount: 0,
  total_payable_amount: 0,
  co_partner_ids: [],
  booking_data: [],
  adjustment_data: [],
};

const columns = [
  {
    title: "Date",
    dataIndex: "holiday_date",
    key: "holiday_date",
    width: 150,
  },
  {
    title: "Description",
    dataIndex: "holiday_description",
    key: "holiday_description",
  },
  {
    title: "Days",
    dataIndex: "number_of_day",
    key: "number_of_day",
  },
  {
    title: "Rate",
    dataIndex: "rate_per_slot",
    key: "rate_per_slot",
  },
];

const TapBookingView = () => {
  const [form] = Form.useForm();
  const params = useParams();
  let navigate = useNavigate();
  const state = useSelector((state) => state.otheritem);

  const [dateSelected, setDateSelected] = useState([]);

  // Use State Initialization
  const [enrollmentID, setEnrollmentID] = useState(0);
  const [receiptID, setReceiptID] = useState(0);
  const [paymentID, setPaymentID] = useState(0);
  const [memberID, setMemberID] = useState(0);
  const [programmeGroupList, setProgrammeGroupList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [playWithMemberList, setPlayWithMemberList] = useState([]);
  const [tapMemberShipFeeAmount, setTapMemberShipFeeAmount] = useState(0);
  const [isAlreadyMemberEnrolled, setIsAlreadyMemberEnrolled] = useState(false);
  const [alreadyMemberEnrolledMessage, setAlreadyMemberEnrolledMessage] =
    useState("");
  const [programmeID, setProgrammeID] = useState([]);
  const [programmeGroupID, setProgrammeGroupID] = useState(0);
  const [accountList, setAccountList] = useState([]);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
  const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
  const [totalCGSTAmount, setTotalCGSTAmount] = useState(0);
  const [totalSGSTAmount, setTotalSGSTAmount] = useState(0);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [totalRoundOff, setTotalRoundOff] = useState(0);
  const [totalBankCharges, setTotalBankCharges] = useState(0);
  const [paymentPaidList, setPaymentPaidList] = useState([]);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [responseModalTitle, setResponseModalTitle] = useState("");
  const [responseModalMessage, setResponseModalMessage] = useState("");
  const [dayList, setDayList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [selectedScheduleDates, setSelectedScheduleDates] = useState([]);
  const [timeSlotList, setTimeSlotList] = useState([]);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [coachList, setCoachList] = useState([]);
  const [bookingTimeSlotList, setBookingTimeSlotList] = useState([]);
  const [memberAdjustmentList, setMemberAdjustmentList] = useState([]);
  const [
    memberAdjustmentAllAmountFromList,
    setMemberAdjustmentAllAmountFromList,
  ] = useState(0);
  const [isSpecialCoaching, setIsSpecialCoaching] = useState(false);
  const [tapGroupSelected, setTapGroupSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [addClickEnableCombination, setAddClickEnableCombination] =
    useState(false);
  const [isClickToAddEnable, setIsClickToAddEnable] = useState(false);
  const [
    scheduleGenerationAddRequiredText,
    setScheduleGenerationAddRequiredText,
  ] = useState("");
  const [bookingValidStartDate, setBookingValidStartDate] = useState(null);
  const [bookingValidEndDate, setBookingValidEndDate] = useState(null);
  const [lastBookingValidity, setLastBookingValidity] = useState([]);
  const [isClickToAddDone, setIsClickToAddDone] = useState(false);

  const [isSaveEnableBooking, setIsSaveEnableBooking] = useState(false);
  const [memberOrTrainer, setMemberOrTrainer] = useState("");
  const [tapGroup, setTapGroup] = useState("");

  const [memberDisplayInfo, setMemberDisplayInfo] = useState({
    memberName: "",
    memberPrimaryMobile: "",
    memberFatherName: "",
    memberDOB: "",
    profilePic: "",
  });
  const [memberDisplayOtherInfo, setMemberDisplayOtherInfo] = useState({
    joinDate: "",
    validity: "",
  });
  const [responseModal, setResponseModal] = useState({
    responseModalTitle: "",
    isOpenModal: false,
    listLink: "",
    addmoreLink: "",
    responseModalMessage: "",
    printReuired: false,
    printUrl: "",
  });

  const [clickToAddFormErr, setClickToAddFormErr] = useState({
    type: "",
    withCoachWithoutCoach: "",
    coachDetail: "",
    rate: "",
    day: "",
    timeSlot: "",
    schedule_dates: "",
    isTrigger: false,
  });




  const memberListRef = useRef([]);

  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [isDiscountEntered, setIsDiscountEntered] = useState(false);
  const [editMemberNameInBooking, setEditMemberNameInBooking] = useState(false);

  // const handleSelect = (value) => {
  //   if (value === "select-all") {
  //     setIsSelectAllChecked(true);
  //     setSelectedScheduleDates(dateList);
  //   } else {
  //     setSelectedScheduleDates(value);
  //   }
  // };

  /**
   * ************************************
   * Function Definations   *************
   * ************************************
   */

  const onSelectMember = (value, event) => {
    setPlayWithMemberList([]);
    setBookingValidStartDate(null);
    setBookingValidEndDate(null);
    setLastBookingValidity([]);


    if (value > 0) {
      setIsAlreadyMemberEnrolled(false);
      setAlreadyMemberEnrolledMessage("");


      const member_id = event.member_id;

      const data = {
        //formdata: { member_id: value, programme_id: programmeID },
        formdata: { member_id: member_id, enrollment_id: value, programme_id: programmeID },
      };
      ProgrammeService.tapMemberDetail(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const response = res.data.response_data;
          const tap_group = form.getFieldValue("tap_group");

          form.setFieldsValue({
            member_id: response.memberData[0].member_id,
            //member_search: response.memberData[0].member_id,
            member_search: response.enrolmentData[0].enrollment_id,
            member_name:
              response.memberData[0].member_fname +
              " " +
              response.memberData[0].member_lname,
            member_primary_mobile: response.memberData[0].primary_mobile,
            member_father_name: response.memberData[0].father_name,
            date_of_birth: response.memberData[0].date_of_birth,
            //  group_id: response.enrolmentData[0].group_id,
            enrollment_id: response.enrolmentData[0].enrollment_id,
            trainee_member:
              tap_group == "TAPSC"
                ? response.enrolmentData[0].member_trainee
                : "",
          });


          setMemberOrTrainer(response.enrolmentData[0].member_trainee);

          setMemberDisplayInfo({
            memberName: `${response.memberData[0].member_fname} ${response.memberData[0].member_lname}`,
            memberPrimaryMobile: response.memberData[0].primary_mobile,
            memberFatherName: response.memberData[0].father_name,
            memberDOB: response.memberData[0].date_of_birth,
            profilePic: response.memberData[0].profile_picture,
          });

          setMemberDisplayOtherInfo({
            joinDate: response.enrolmentData[0].enrollment_date,
            validity: `${response.enrolmentData[0].enrollment_start_date} to ${response.enrolmentData[0].enrollment_end_date}`,
          });

          form.setFieldsValue({
            date_of_join: response.enrolmentData[0].enrollment_date,
          });

          setEnrollmentID(response.enrolmentData[0].enrollment_id);
          setProgrammeGroupID(response.enrolmentData[0].group_id);
          setMemberID(response.memberData[0].member_id);

          /*
                              const filteredItems = memberList.filter(item => item.member_id != response.memberData[0].member_id);
                              setPlayWithMemberList(filteredItems);
                              */

          generatePlayWithMemberShipList(
            member_id,
            response.enrolmentData[0].enrollment_start_date,
            response.enrolmentData[0].enrollment_end_date
          );

          if (response?.lastBookingData?.length > 0) {
            //setBookingValidStartDate(response.lastBookingData[0].tap_end_date);
            //setBookingValidEndDate(response.enrolmentData[0].enrollment_end_date);
            /*
            const group =
              response.lastBookingData[0].tap_group == "TAPM"
                ? "Adult Coaching"
                : "Special Coaching";
            setLastBookingValidity(
              response.lastBookingData[0].tap_start_date +
              " to " +
              response.lastBookingData[0].tap_end_date +
              "(" +
              group +
              ")"
            );
          */

            setLastBookingValidity(response?.lastBookingData);
            //let previousBookingList = response?.lastBookingData;

          } else if (
            response?.enrolmentData?.length &&
            response?.lastBookingData?.length <= 0
          ) {
            //setBookingValidStartDate(response.enrolmentData[0].enrollment_start_date);
            //setBookingValidEndDate(response.enrolmentData[0].enrollment_end_date);
            // setLastBookingValidity("");
            setLastBookingValidity([]);
          }

          setBookingValidStartDate(
            response.enrolmentData[0].enrollment_start_date
          );
          setBookingValidEndDate(response.enrolmentData[0].enrollment_end_date);
        }
      });

      setAddClickEnableCombination(!addClickEnableCombination);
      populateMemberAdjustment();
      //getCoachList();
    }
  };

  const generatePlayWithMemberShipList = (
    member_id,
    validity_start_date,
    validity_end_date
  ) => {
    setPlayWithMemberList([]);
    form.setFieldsValue({
      co_partner_ids: [],
    });

    const data = {
      formdata: {
        member_id: member_id,
        validity_start_date: validity_start_date,
        validity_end_date: validity_end_date,
      },
    };
    memberService.tapCoMemberList(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setPlayWithMemberList(res.data.response_data);
      }
    });
  };

  const onBookingStartDateChange = (date, dateString) => {
    form.setFieldsValue({
      from_date: dateString,
    });
    setAddClickEnableCombination(!addClickEnableCombination);
  };

  const onBookingEndDateChange = (date, dateString) => {
    form.setFieldsValue({
      to_date: dateString,
    });
    setAddClickEnableCombination(!addClickEnableCombination);
  };

  const generateValidityPeriod = (dateString, no_of_month) => {
    const formatDate = dateString.split("/").reverse().join("-");
    const joindate = new Date(formatDate);
    const validity_end_date = commonUtility.addMonthsToDate(
      parseInt(no_of_month),
      joindate
    );

    form.setFieldsValue({
      enrollment_date: dateString,
      enrollment_start_date: dateString,
      enrollment_end_date: validity_end_date,
    });

    setMemberDisplayOtherInfo({
      joinDate: dateString,
      validity: `${dateString} to ${validity_end_date.split("-").join("/")}`,
    });
  };

  const onTapSpecialChange = (value, obj) => {
    setIsSpecialCoaching(false);
    setCoachList([]);
    setBookingTimeSlotList([]);
    setTapGroup(value);
    form.setFieldsValue({
      tap_group_txt: obj?.valueText != undefined ? obj?.valueText : "",
      trainee_member: "",
      coach_rate_detail_id: "",
      coach_detail_txt: "",
      is_with_coach_txt: "",
      coach_master_id: "",
      is_with_coach: "",
      rate_per_slot: 0,
      time_slot_id: [],
      day_id: "",
      coaching_amount_per_slot: 0,
      bta_amount_per_slot: 0,
      coach_amount_slot: 0,
    });
    setTapGroupSelected(false);

    if (value == "TAPM") {
      setIsSpecialCoaching(false);
      form.setFieldsValue({
        is_with_coach: "",
        rate_per_slot: 0,
        time_slot_id: [],
        day_id: "",
        trainee_member: memberOrTrainer,
        cr_ac_id: TAP_BOOKING_CREDIT_ACCOUNT_ID,
      });
      setTapGroupSelected(true);
    } else if (value == "TAPSC") {
      setIsSpecialCoaching(true);
      form.setFieldsValue({
        coach_master_id: "",
        rate_per_slot: 0,
        time_slot_id: [],
        day_id: "",
        trainee_member: memberOrTrainer,
        cr_ac_id: TAP_BOOKING_SPECIAL_COACHING_CREDIT_ACCOUNT_ID,
      });
      setTapGroupSelected(true);
      getCoachList();
    }

    // else{
    //     setIsSpecialCoaching(false)
    //     setCoachList([]);
    //     form.setFieldsValue({
    //         tap_group_txt: obj?.valueText != undefined ? obj?.valueText : "",
    //         trainee_member: "",
    //         coach_rate_detail_id : "",
    //         coach_master_id: '',
    //         is_with_coach:"" ,
    //         rate_per_slot:0,
    //         time_slot_id:'',
    //         day_id:''
    //     });
    //     setTapGroupSelected(false)
    // }

    setIsClickToAddDone(false);

    // setBookingTimeSlotList([])
    populateMemberAdjustment();
    populateTimeSlot();
  };

  const OnTraineeMemberChange = (value, obj) => {
    getCoachList();
  };

  const onChangeWithCoachWithoutCoach = (value, obj) => {
    console.log("changewithCoachWithoutCoach", value);
    form.setFieldsValue({
      is_with_coach_txt: obj?.valueText != undefined ? obj?.valueText : "",
    });
    setIsClickToAddDone(false);
    bookingRate(value);
  };

  const onChangeCoach = (v, e) => {
    form.setFieldsValue({
      rate_per_slot: 0,
    });
    if (e) {
      const is_waiver = form.getFieldValue("is_waiver");
      const is_with_coach = form.getFieldValue("is_with_coach");

      form.setFieldsValue({
        //rate_per_slot: is_waiver == "Y" ? 0 : e.coaching_fee,
        coach_master_id: e.coach_id,
        coach_detail_txt:
          e.coach_name + " - " + e.ratio_name + " - " + e.time_tag,
      });
      bookingRate(is_with_coach);
    }
    setIsClickToAddDone(false);
  };

  const bookingRate = (is_with_coach) => {
    const is_waiver = form.getFieldValue("is_waiver");
    //const is_with_coachX = form.getFieldValue("is_with_coach");

    const coach_rate_detail_id = form.getFieldValue("coach_rate_detail_id");
    const tap_group = form.getFieldValue("tap_group");
    console.log("tapsc", tap_group);

    const coachObject = coachList.filter(
      (item) => item.rate_details_id === coach_rate_detail_id
    );
    form.setFieldsValue({
      coaching_amount_per_slot: 0,
      bta_amount_per_slot: 0,
      coach_amount_slot: 0,
      rate_per_slot: 0,
    });
    if (coachObject.length > 0) {
      if (commonUtility.sanitizeObject(is_with_coach) != "") {
        if (is_with_coach == "Y") {
          form.setFieldsValue({
            rate_per_slot: is_waiver == "Y" ? 0 : coachObject[0].coaching_fee,
          });
        } else if (is_with_coach == "C") {
          form.setFieldsValue({
            rate_per_slot: is_waiver == "Y" ? 0 : coachObject[0].coach_amount,
          });
        } else {
          form.setFieldsValue({
            rate_per_slot: is_waiver == "Y" ? 0 : coachObject[0].bta_amount,
          });
        }

        form.setFieldsValue({
          coaching_amount_per_slot: coachObject[0].coaching_fee,
          bta_amount_per_slot: coachObject[0].bta_amount,
          coach_amount_slot: coachObject[0].coach_amount,
        });
      }
    } else {
      ProgrammeService.tapMembershipFee().then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const fee_data = res.data.response_data[0];

          if (commonUtility.sanitizeObject(is_with_coach) != "") {
            if (is_with_coach == "Y") {
              form.setFieldsValue({
                rate_per_slot:
                  is_waiver == "Y" ? 0 : fee_data.court_charges_with_coach,
              });
            } else if (is_with_coach == "C") {
              form.setFieldsValue({
                rate_per_slot: is_waiver == "Y" ? 0 : fee_data.coach_fees,
              });
            } else if (is_with_coach == "MD") {
              form.setFieldsValue({
                rate_per_slot: is_waiver == "Y" ? 0 : fee_data.member_day_rate,
              });
            } else if (is_with_coach == "MN") {
              form.setFieldsValue({
                rate_per_slot:
                  is_waiver == "Y" ? 0 : fee_data.member_night_rate,
              });
            } else if (is_with_coach == "TD") {
              form.setFieldsValue({
                rate_per_slot: is_waiver == "Y" ? 0 : fee_data.trainee_day_rate,
              });
            } else if (is_with_coach == "TN") {
              form.setFieldsValue({
                rate_per_slot:
                  is_waiver == "Y" ? 0 : fee_data.trainee_night_rate,
              });
            } else {
              form.setFieldsValue({
                rate_per_slot: is_waiver == "Y" ? 0 : fee_data.court_charges,
              });
            }
          }

          form.setFieldsValue({
            coaching_amount_per_slot: fee_data.court_charges_with_coach,
            bta_amount_per_slot: fee_data.court_charges,
            coach_amount_slot: fee_data.coach_fees,
          });
        }
      });
    }
  };

  const populateTimeSlot = () => {
    setTimeSlotList([]);
    form.setFieldsValue({
      time_slot_id: [],
    });
    const data = {
      formdata: {
        programme_id: programmeID,
        programme_group_id: form.getFieldValue("tap_group"),
        day_id: form.getFieldValue("day_id"),
      },
    };
    timeSlotService.timeSlotByProgrammeAndGroupTAP(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        res.data.response_data.length > 0
          ? setTimeSlotList(res.data.response_data)
          : setTimeSlotList([]);
      }
    });
  };

  const populateDateByDay = () => {
    setTimeSlotList([]);
    form.setFieldsValue({
      schedule_dates: [],
    });
    const data = {
      formdata: {
        from_date: form.getFieldValue("from_date"),
        to_date: form.getFieldValue("to_date"),
        day_id: form.getFieldValue("day_id"),
      },
    };

    timeSlotService.tapBookingDayDates(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        /*
        
        console.log('res.data.response_data', res.data.response_data);
        
        let dateList = res.data.response_data;
        let dateListObj = [];
        dateList.map((item) => {
          console.log('item',item);
          dateListObj.push({
            label: item,
            value: item
          });
        });
        */

        res.data.response_data.length > 0 ? setDateList(res.data.response_data) : setDateList([]);
        //res.data.response_data.length > 0? setDateList(dateListObj): setDateList([]);
      }
    });
  };

  const clickToAddEnable = () => {
    if (
      form.getFieldValue("member_id") > 0 &&
      form.getFieldValue("from_date") &&
      form.getFieldValue("to_date")
    ) {
      setIsClickToAddEnable(true);
    } else {
      setIsClickToAddEnable(false);
    }
  };

  const generateTapBookingDays = () => {
    setScheduleGenerationAddRequiredText("");
    const from_date = form.getFieldValue("from_date");
    const to_date = form.getFieldValue("to_date");
    const time_slot = form.getFieldValue("time_slot_id") || [];
    //const schedule_dates = form.getFieldValue("schedule_dates") || [];
    const schedule_dates = selectedScheduleDates || [];
    const discount = form.getFieldValue("discount") || 0;

    //console.log('form.getFieldValue("schedule_dates")',form.getFieldValue("schedule_dates"));

    const day_id =
      form.getFieldValue("day_id") != undefined
        ? form.getFieldValue("day_id")
        : "";
    const time_slot_id =
      time_slot.length > 0 ? form.getFieldValue("time_slot_id") : [];

    //const day_dates = schedule_dates.length > 0 ? form.getFieldValue("schedule_dates") : [];
    const day_dates = schedule_dates.length > 0 ? selectedScheduleDates : [];

    const rate_per_slot =
      form.getFieldValue("rate_per_slot") != undefined
        ? form.getFieldValue("rate_per_slot")
        : "";

    let tap_group =
      form.getFieldValue("tap_group") != undefined
        ? form.getFieldValue("tap_group")
        : "";
    let tap_group_txt =
      form.getFieldValue("tap_group_txt") != undefined
        ? form.getFieldValue("tap_group_txt")
        : "";

    let trainee_member =
      form.getFieldValue("trainee_member") != undefined
        ? form.getFieldValue("trainee_member")
        : "";
    let is_with_coach =
      form.getFieldValue("is_with_coach") != undefined
        ? form.getFieldValue("is_with_coach")
        : "";
    let is_with_coach_txt =
      form.getFieldValue("is_with_coach_txt") != undefined
        ? form.getFieldValue("is_with_coach_txt")
        : "";
    let coach_rate_detail_id =
      form.getFieldValue("coach_rate_detail_id") != undefined
        ? form.getFieldValue("coach_rate_detail_id")
        : "";
    let coach_detail_txt =
      form.getFieldValue("coach_detail_txt") != undefined
        ? form.getFieldValue("coach_detail_txt")
        : "";
    let coach_master_id =
      form.getFieldValue("coach_master_id") != undefined
        ? form.getFieldValue("coach_master_id")
        : "";

    let coaching_amount_per_slot =
      form.getFieldValue("coaching_amount_per_slot") != undefined
        ? form.getFieldValue("coaching_amount_per_slot")
        : 0;
    let bta_amount_per_slot =
      form.getFieldValue("bta_amount_per_slot") != undefined
        ? form.getFieldValue("bta_amount_per_slot")
        : 0;
    let coach_amount_slot =
      form.getFieldValue("coach_amount_slot") != undefined
        ? form.getFieldValue("coach_amount_slot")
        : 0;

    const data = {
      formdata: {
        from_date: from_date,
        to_date: to_date,
        day_id: day_id,
        day_dates: day_dates,
        time_slot_id: time_slot_id,
        rate_per_slot: rate_per_slot,
        tap_group: tap_group,
      },
    };

    console.log('data', data);

    setClickToAddFormErr({
      //type: tap_group_txt,
      //type: trainee_member,
      trainee_member: trainee_member,
      is_with_coach_txt: is_with_coach_txt,
      coach_detail_txt: coach_detail_txt,
      rate_per_slot: rate_per_slot,
      day_id: day_id,
      time_slot_id: time_slot_id,
      schedule_dates: schedule_dates,
      isTrigger: true,
    });

    if (
      validateAddSchedule(
        tap_group,
        is_with_coach_txt,
        coach_detail_txt,
        day_id,
        schedule_dates,
        time_slot_id
      )
    ) {
      setScheduleGenerationAddRequiredText("");
      // return false;

      /* This is for single row value 
                  timeSlotService.generateBookingDays(data).then((res) => {
                      if (res.data.response_status === SUCCESS_STATUS) {
                          const booking_data = res.data.response_data;
                          if (booking_data.no_of_days > 0) {
                              
                              const holidayList = `${booking_data.holidayDates
                                  .map(({ holiday_date, holiday_description }) => `${holiday_date} (${holiday_description})`)
                                  .join(",")}`;
                              setBookingTimeSlotList([...bookingTimeSlotList, {
                                  unique_id: commonUtility.randomID(),
                                  day_id: booking_data.day_id,
                                  day_code: booking_data.day_code,
                                  day_name: booking_data.day_name,
                                  time_slot_id: booking_data.time_slot_id,
                                  start_time: booking_data.start_time,
                                  end_time: booking_data.end_time,
                                  time_slot: booking_data.time_slot,
                                  rate_per_slot: booking_data.rate_per_slot,
                                  // no_of_holidays: booking_data.no_of_holidays,
                                  no_of_days: booking_data.no_of_days,
                                  total_value: booking_data.total_value,
                                  available_dates: booking_data.available_dates,
                                  trainee_member : trainee_member,
      
                                  // tap_group: tap_group,
                                  // tap_group_txt: tap_group_txt,
      
                                  is_with_coach: is_with_coach,
                                  is_with_coach_txt: is_with_coach_txt,
                                  coach_detail_txt: coach_detail_txt,
                                  coach_rate_detail_id: coach_rate_detail_id,
                                  coach_master_id: coach_master_id,
                                  holiday_list:holidayList,
                                  coaching_amount_per_slot:coaching_amount_per_slot,
                                  bta_amount_per_slot:bta_amount_per_slot,
                                  coach_amount_slot:coach_amount_slot,
                                  //holiday_list:
                              }]);
      
      
                              form.setFieldsValue({
                                 // tap_group_txt: "",
                                 // tap_group: "",
                                  is_with_coach_txt: "",
                                  coach_detail_txt: "",
                                  coach_master_id: 0,
                                  time_slot_id: '',
                                  rate_per_slot: 0,
                                  is_with_coach: "",
                                  trainee_member:trainee_member,
                                  day_id: '',
                                  coach_rate_detail_id: '',
                                  coaching_amount_per_slot : 0,
                                  bta_amount_per_slot : 0,
                                  coach_amount_slot : 0,
                              });
                              //setCoachList([])
      
                              setClickToAddFormErr({
                                isTrigger:false
                              })
      
      
                          } else {
                              commonUtility.openNotificationWithType("info", "right", "No Dates Available", "There is no schedule availables for this combinations.")
                          }
                      }
                  });
                  */

      /**
       * Multiple time slot id selection
       */

      timeSlotService.generateBookingDays(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const bookingDataList = res.data.response_data; // Array of booking_data
          if (bookingDataList.length > 0) {
            bookingDataList.forEach((booking_data) => {
              if (booking_data.no_of_days > 0) {
                const holidayList = booking_data.holidayDates
                  .map(
                    ({ holiday_date, holiday_description }) =>
                      `${holiday_date} (${holiday_description})`
                  )
                  .join(",");

                setBookingTimeSlotList((prevList) => [
                  ...prevList,
                  {
                    unique_id: commonUtility.randomID(),
                    day_id: booking_data.day_id,
                    day_code: booking_data.day_code,
                    day_name: booking_data.day_name,
                    time_slot_id: booking_data.time_slot_id,
                    start_time: booking_data.start_time,
                    end_time: booking_data.end_time,
                    time_slot: booking_data.time_slot,
                    rate_per_slot: booking_data.rate_per_slot,
                    no_of_days: booking_data.no_of_days,
                    total_value: booking_data.total_value,
                    available_dates: booking_data.available_dates,
                    holidayDates: booking_data.holidayDates,
                    no_of_holiday: booking_data.no_of_holiday,
                    trainee_member: trainee_member,
                    is_with_coach: is_with_coach,
                    is_with_coach_txt: is_with_coach_txt,
                    coach_detail_txt: coach_detail_txt,
                    coach_rate_detail_id: coach_rate_detail_id,
                    coach_master_id: coach_master_id,
                    holiday_list: holidayList,
                    coaching_amount_per_slot: coaching_amount_per_slot,
                    bta_amount_per_slot: bta_amount_per_slot,
                    coach_amount_slot: coach_amount_slot,
                  },
                ]);

                // Reset form fields and errors
                form.setFieldsValue({
                  is_with_coach_txt: "",
                  coach_detail_txt: "",
                  coach_master_id: 0,
                  time_slot_id: [],
                  schedule_dates: [],
                  rate_per_slot: 0,
                  is_with_coach: "",
                  trainee_member: trainee_member,
                  day_id: "",
                  coach_rate_detail_id: "",
                  coaching_amount_per_slot: 0,
                  bta_amount_per_slot: 0,
                  coach_amount_slot: 0,
                });


                setClickToAddFormErr({
                  isTrigger: false,
                });
                setSelectedScheduleDates([]);

              } else {
                commonUtility.openNotificationWithType(
                  "info",
                  "right",
                  "No Dates Available",
                  "There are no schedules available for this combination."
                );

              }

            });
          } else {
            commonUtility.openNotificationWithType(
              "info",
              "right",
              "No Dates Available",
              "There are no schedules available for this combination."
            );

          }


        }
      });
    } else {
      //console.log('dahdkhsdkjh');
      setScheduleGenerationAddRequiredText("(Required)");
      commonUtility.openNotificationWithType(
        "error",
        "right",
        "Required Field",
        "All * Fields are required."
      );

    }

    // reset detail entry
  };

  const validateAddSchedule = (
    tap_group,
    is_with_coach_txt,
    coach_detail_txt,
    day_id,
    time_slot_id,
    schedule_dates
  ) => {
    console.log("time_slot_id", time_slot_id);
    if (
      tap_group != "" &&
      (is_with_coach_txt != "" || coach_detail_txt != "") &&
      day_id != "" &&
      time_slot_id.length > 0 &&
      schedule_dates.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const removeBooking = (index) => {
    const list = [...bookingTimeSlotList];
    list.splice(index, 1);
    setBookingTimeSlotList(list);
  };

  const onTapBookingSave = async (values) => {
    // setSaveLoaderEnable(true)
    // e.preventDefault()

    let isWaveReceipt;
    if (values.payable_amount === 0) {
      isWaveReceipt = "Y";
    } else {
      isWaveReceipt = "N";
    }

    const data = {
      formdata: {
        ...values,
        is_wave_receipt: isWaveReceipt
      }
    };

    // const data = { formdata: values };
    console.log('Tapdata', data);

    //return false;

    // setOpenModal(false);
    // setResponseModalTitle("")
    // setResponseModalMessage("")

    setResponseModal({
      responseModalTitle: "",
      isOpenModal: false,
      listLink: "",
      addmoreLink: "",
      responseModalMessage: "",
      printReuired: false,
      printUrl: "",
    });

    if (values.booking_data.length > 0) {
      if (values.payment_data.length > 0) {
        setSaveLoaderEnable(true);

        enrollmentService
          .tapBookingSave(data)
          .then((res) => {
            // console.log("TapRes", res)
            if (isWaveReceipt === 'Y') {
              notification.error({
                message: 'No Reciept No. Generated',
                description: 'Reciept No. will not be generated against this transaction.',
                placement: 'bottom',
                style: { color: 'red' }
              });
            }
            if (res.data.response_status == SUCCESS_STATUS) {
              if (res.data.response_data.enrollment_id > 0) {
                const resp_data = res.data.response_data;
                const print_url = `${PRINT_BASE_URL}tap/printpdf/${resp_data.enrollment_id
                  }/${resp_data.receipt_master_id}/${resp_data.payment_master_id
                  }/${commonUtility.getLoggedInUserInfo()?.companyID > 0
                    ? commonUtility.getLoggedInUserInfo()?.companyID
                    : 0
                  }`;

                // console.log('resp_data',resp_data);
                // alert("Saved")

                setResponseModal({
                  responseModalTitle: "Success",
                  isOpenModal: true,
                  listLink: "/tap/bookinglist",
                  addmoreLink: "/tap/booking",
                  responseModalMessage: res.data.response_msg,
                  printReuired: true,
                  printUrl: print_url,
                });
              } else {
                commonUtility.openNotificationWithType(
                  "error",
                  "bottomRight",
                  "Error",
                  TRY_AGAIN_ERROR
                );
              }
            }

            /*
                                if(res.data.response_status == SUCCESS_STATUS && res.data.response_data.affectedRows == undefined) {
                                    setOpenModal(true)
                                    setResponseModalTitle("Success")
                                    setResponseModalMessage(`${SAVE_SUCCESS_MSG}`)
                                    setResponseModal({
                                        responseModalTitle: 'Success',
                                        isOpenModal: true,
                                        listLink: '/tap/bookinglist',
                                        addmoreLink: '/tap/booking',
                                        responseModalMessage: SAVE_SUCCESS_MSG,
                                        printReuired: false,
                                       
                                    });
                    
                                } else if (res.data.response_data.affectedRows > 0) {
                                    setResponseModal({
                                        responseModalTitle: 'Success',
                                        isOpenModal: true,
                                        listLink: '/tap/bookinglist',
                                        addmoreLink: '/tap/booking',
                                        responseModalMessage: SAVE_SUCCESS_MSG,
                                        printReuired: false
                                    });
                                }
                                */
            setSaveLoaderEnable(false);
          })
          .then(() => {
            // setSaveLoaderEnable(false)
          });
      } else {
        commonUtility.openNotificationWithType(
          "error",
          "bottomRight",
          "Error",
          ADD_ONE_PAYMENT_MODE
        );
      }
    } else {
      commonUtility.openNotificationWithType(
        "error",
        "bottomRight",
        "Error",
        TIME_SLOT_REQUIRED
      );
    }
  };

  /**
   * 02. onTapSpecialChange
   */

  const populateMemberAdjustment = () => {
    setMemberAdjustmentList([]);
    const mode = form.getFieldValue("mode");
    const memberid = form.getFieldValue("member_id");
    const co_partner_ids = form.getFieldValue("co_partner_ids");
    const tap_group = form.getFieldValue("tap_group");
    const is_waiver = form.getFieldValue("is_waiver");




    const receipt_master_id =
      mode == EDIT_MODE ? receiptID : form.getFieldValue("receipt_id");

    if (is_waiver == "N") {
      const data = {
        formdata: {
          member_id: memberid,
          receipt_master_id: receipt_master_id,
          co_partner_ids: co_partner_ids,
          tap_group: tap_group,
        },
      };

      ProgrammeService.memberAdjustmentList(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          let list = res.data.response_data;
          if (list.length > 0) {
            let data = [];
            let selectedKeys = [];
            for (let i = 0; i < list.length; i++) {
              data.push({
                //key: commonUtility.randomID(),
                key: list[i].booking_cancle_id,
                adult_booking_id: list[i].adult_booking_id,
                booking_cancle_id: list[i].booking_cancle_id,
                booking_dtl_id: list[i].booking_dtl_id,
                enrollment_id: list[i].enrollment_id,
                holiday_date: list[i].holiday_date,
                holiday_description: list[i].holiday_description,
                holiday_id: list[i].holiday_id,
                is_adjust: list[i].is_adjust,
                member_id: list[i].member_id,
                number_of_day: list[i].number_of_day,
                // no_of_holidays: booking_data.no_of_holidays,
                rate_per_slot: list[i].rate_per_slot,
                receipt_master_id: list[i].receipt_master_id,
              });

              // if (list[i].is_adjust == "Y") {
              //     selectedKeys.push(list[i].booking_cancle_id)
              // }
            }
            console.log("populateMemberAdjustment selectedKeys", selectedKeys);
            setSelectedRowKeys(selectedKeys);
            setMemberAdjustmentList(data);
          }
        }
      });
    }
    setAddClickEnableCombination(!addClickEnableCombination);
  };

  // Need to check later

  useEffect(() => {
    console.log("selectedRowKeys", selectedRowKeys);

    if (memberAdjustmentList.length > 0) {
      const defaultSelection = memberAdjustmentList.map((item) => item.key);
      setSelectedRowKeys(defaultSelection);
      const totalAdjustmentAmt = totalAdjustedAmount(memberAdjustmentList);
      form.setFieldsValue({
        adjustment_data: memberAdjustmentList,
      });
      calculateAdjustedAndTaxableAmount(totalAdjustmentAmt);
    }
    else {
      let discount = form.getFieldValue('discount') || 0;
      calculateAdjustedAndTaxableAmount(discount);
    }



  }, [memberAdjustmentList]);


  /* When on change will be used again in future code nedd to be uncommented
      const onSelectChange = (newSelectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${newSelectedRowKeys}`, 'selectedRows: ', selectedRows);
          setSelectedRowKeys(newSelectedRowKeys);
  
          const totalAdjustmentAmt = totalAdjustedAmount(selectedRows);
          form.setFieldsValue({
              adjustment_data: selectedRows,
          });
          calculateAdjustedAndTaxableAmount(totalAdjustmentAmt);
      };
      */

  const rowSelection = {
    selectedRowKeys: memberAdjustmentList.map((item) => item.booking_cancle_id),
    //selectedRowKeys : selectedRowKeys,

    getCheckboxProps: () => ({
      disabled: true,
      //defaultChecked: true,
    }),
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],

    //onChange: onSelectChange,
  };

  const totalAdjustedAmount = (array) => {
    const totalAdjustmentAmt = array.reduce(
      (prev, next) => prev + parseFloat(next.rate_per_slot),
      0
    );
    return totalAdjustmentAmt;
  };

  const calculateAdjustedAndTaxableAmount = (totalAdjustmentAmt) => {



    let adjustment_amount = !isNaN(totalAdjustmentAmt) && totalAdjustmentAmt != "" ? totalAdjustmentAmt : 0;
    //console.log('totalAdjustedAmount',adjustment_amount);

    const total_schedule_amount = parseFloat(form.getFieldValue("total_schedule_amount")) > 0 ? parseFloat(form.getFieldValue("total_schedule_amount")) : 0;

    //const adjusted_amount = parseFloat(totalAdjustmentAmt);
    const adjusted_amount = parseFloat(adjustment_amount);
    const taxable_amount = parseFloat(total_schedule_amount) - parseFloat(adjusted_amount);

    //console.log("total_schedule_amount",total_schedule_amount,"adjusted_amount",adjusted_amount,"taxable_amount",taxable_amount);



    form.setFieldsValue({
      discount: adjusted_amount,
      total_payable_amount: taxable_amount,
      taxable_amount: taxable_amount,
      net_amount: taxable_amount,
      adjustment_note: form.getFieldValue("adjustment_note") || ""
    });




    validAdjustmentValidation();
    onFormCalculation();
  };

  // Payment mode Data
  const [isPaymentModeDisabled, setIsPaymentModeDisabled] = useState(false);
  const addPaymentMode = () => {
    const selected_payment_mode_text = form.getFieldValue(
      "selected_payment_mode_text"
    );
    const mode = form.getFieldValue("selected_payments_mode");
    const paid_amount = form.getFieldValue("paid_amount");
    const dr_account_id = form.getFieldValue("dr_account_id");
    const cheque_no = form.getFieldValue("cheque_no");
    const cheque_date = form.getFieldValue("cheque_date");
    const bank = form.getFieldValue("bank");
    const branch = form.getFieldValue("branch");
    const bank_charges = commonUtility.sanitizeValue(
      form.getFieldValue("bank_charges")
    );
    const payment_ref = form.getFieldValue("payment_ref");

    let bank_charges_amount = 0;
    if (commonUtility.sanitizeValue(bank_charges) > 0) {
      bank_charges_amount =
        (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
      bank_charges_amount = Math.round(bank_charges_amount);
    }

    //setIsOtherComponentRender(false)

    if (
      commonUtility.sanitizeObject(selected_payment_mode_text) &&
      commonUtility.sanitizeObject(mode) &&
      commonUtility.sanitizeValue(paid_amount) >= 0
    ) {
      let amount = parseFloat(paid_amount) + parseFloat(bank_charges_amount);
      setPaymentPaidList([
        ...paymentPaidList,
        {
          rowKey: commonUtility.randomID(),
          mode_description: selected_payment_mode_text,
          payment_mode_text: selected_payment_mode_text,
          payment_mode_id: mode,
          payment_mode: mode,
          dr_account_id: dr_account_id,
          amount: amount,
          paid_amount: paid_amount,
          cheque_no: cheque_no,
          cheque_date: cheque_date,
          bank_name: bank,
          bank_branch: branch,
          bank_charges: bank_charges_amount,
          payment_ref: payment_ref,
        },
      ]);

      setIsPaymentModeDisabled(true);


      form.setFieldsValue({
        selected_payment_mode_text: "",
        selected_payments_mode: "",
        cheque_no: "",
        cheque_date: "",
        bank: "",
        payment_ref: "",
        cheque_date_picker: "",
      });
    } else {
      commonUtility.openNotificationWithType(
        "error",
        "bottomRight",
        "Error",
        PAYMENT_SECTION_REQUIRED_MESSAGE
      );
    }
  };

  // Remove payment Mode
  const removePayment = (index) => {
    const list = [...paymentPaidList];
    list.splice(index, 1);
    setPaymentPaidList(list);
    if (list.length === 0) {
      setIsPaymentModeDisabled(false);
    }
  };

  const onWaveChange = (value, e) => {
    showConfirm(value);
  };

  const resetComponentForWaive = (v) => {
    form.setFieldsValue({
      discount: 0,
      total_payable_amount: 0,
      total_schedule_amount: 0,
      payable_amount: 0,
      amount: 0,
    });
    setBookingTimeSlotList([]);
    setMemberAdjustmentList([]);
    setPaymentPaidList([]);
    onFormCalculation();

    if (v == "N") {
      populateMemberAdjustment();
    }
  };

  const showConfirm = (v) => {
    confirm({
      title: "Do you want to change waive option?",
      icon: <ExclamationCircleFilled />,
      content:
        "Please note that if you confirm, the schedule list and adjustment list will be cleared.",
      onOk() {
        resetComponentForWaive(v);
      },
      onCancel() {
        if (v == "N") {
          form.setFieldsValue({
            is_waiver: "Y",
          });
        } else {
          form.setFieldsValue({
            is_waiver: "N",
          });
        }
      },
    });
  };

  /*
      const handleConfirmWaive = () => {
          // handle confirm logic here
          console.log('Teytsdyhgfhjsfhj');
          setOpenWaivePopUp(false);
        };
      
        const handleCancelWaive = () => {
          // handle cancel logic here
        };
  
      const renderPopconfirm = () => {
          return (
            <Popconfirm
              title="Are you sure to proceed?"
              visible={openWaivePopUp}
              onConfirm={handleConfirmWaive}
              onCancel={handleCancelWaive}
            >
            
            </Popconfirm>
          );
        };
      
        */




  const validAdjustmentValidation = () => {

    let total_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("amount")));
    let total_discount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("discount")));
    setIsSaveEnableBooking(false);
    if (total_discount > total_amount) {
      setIsSaveEnableBooking(true);
      commonUtility.openNotificationWithType(
        "error",
        "bottomRight",
        "Error",
        "Adjusted amount should not be greater than Total Amount"
      );
    }
    else if ((total_amount == 0 && total_discount == 0) || (total_amount >= total_discount)) {
      setIsSaveEnableBooking(false);
    }
  }

  useEffect(() => {
    //console.log('totalAmount',totalAmount);
    //console.log('totalDiscountAmount',totalDiscountAmount);

    //validAdjustmentValidation();


  }, [totalAmount]);




  const onFormCalculation = () => {

    setIsFormChanged(false);
    setTotalAmount(0);
    setTotalDiscountAmount(0);
    setTotalTaxableAmount(0);
    setTotalCGSTAmount(0);
    setTotalSGSTAmount(0);
    setTotalNetAmount(0);
    setTotalPayableAmount(0);
    setTotalRoundOff(0);

    let total_amount = parseFloat(
      commonUtility.sanitizeValue(form.getFieldValue("amount"))
    );
    let total_discount = parseFloat(
      commonUtility.sanitizeValue(form.getFieldValue("discount"))
    );



    let total_taxable = parseFloat(
      commonUtility.sanitizeValue(form.getFieldValue("total_payable_amount"))
    );
    let total_schedule_amount = parseFloat(
      commonUtility.sanitizeValue(form.getFieldValue("total_schedule_amount"))
    );
    let total_cgst_amount = 0;
    let total_sgst_amount = 0;
    let total_payable_amount =
      parseFloat(commonUtility.sanitizeValue(total_taxable)) +
      parseFloat(commonUtility.sanitizeValue(total_cgst_amount)) +
      parseFloat(commonUtility.sanitizeValue(total_sgst_amount));
    //let total_payable_amount = parseFloat(commonUtility.sanitizeValue(total_schedule_amount))  - parseFloat(commonUtility.sanitizeValue(total_discount));

    const payableAmountDetail =
      commonUtility.getRoundOfAmount(total_payable_amount);
    const new_payable_amount = payableAmountDetail.newPayableAmount;
    const roundoff_amount = payableAmountDetail.roundoffAmount;

    //memberAdjustmentAmountFromList
    let total_adjustment_amount_of_list = memberAdjustmentList.reduce(
      (total, list) => total + parseInt(list.rate_per_slot, 0),
      0
    );

    //console.log('total_adjustment_amount_of_list',total_adjustment_amount_of_list);



    form.setFieldsValue({
      payable_amount: new_payable_amount,
      // total_payable_amount: total_amount - total_discount,
      round_off_amount: roundoff_amount,
    });

    setTotalAmount(total_amount.toFixed(2));
    setTotalDiscountAmount(total_discount.toFixed(2));
    setTotalTaxableAmount(total_taxable.toFixed(2));
    setTotalCGSTAmount(total_cgst_amount.toFixed(2));
    setTotalSGSTAmount(total_sgst_amount.toFixed(2));
    setTotalNetAmount(total_payable_amount.toFixed(2));
    setTotalPayableAmount(new_payable_amount.toFixed(2));
    setMemberAdjustmentAllAmountFromList(total_adjustment_amount_of_list);

    setTotalRoundOff(0);
    if (roundoff_amount) {
      setTotalRoundOff(`${roundoff_amount}`);
    }


    setIsFormChanged(true);
  };

  function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  const getCoachList = () => {
    form.setFieldsValue({
      coach_rate_detail_id: "",
    });
    setCoachList([]);

    console.log('tapGroup : ) ;', tapGroup);
    console.log('memberOrTrainer : ) ; ', memberOrTrainer);

    //if (commonUtility.sanitizeObject(form.getFieldValue("tap_group")) != "") {
    if (tapGroup != "") {
      const data = {
        //formdata: { trainee_member: form.getFieldValue("trainee_member") },
        formdata: { trainee_member: memberOrTrainer },
      };
      ProgrammeService.coachListWithRatioRateWithType(data).then((res) => {
        //console.log('res.data.response_data',res.data.response_data);
        setCoachList(res.data.response_data);
      });
    }
  };

  /**
   * **************************
   * UseEffects Implementation
   * **************************
   */

  useEffect(() => {
    clickToAddEnable();
  }, [addClickEnableCombination]);

  useEffect(() => {
    const rcpt_dt = commonUtility.dateFormatDDMMYYYY(new Date(), "/");
    form.setFieldsValue({
      receipt_date: rcpt_dt,
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: { short_code: "TAP" },
    };
    ProgrammeService.programmeByCode(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeID(res.data.response_data[0].programme_id);
        form.setFieldsValue({
          programme_id: res.data.response_data[0].programme_id,
        });
      }
    });
  }, []);

  useEffect(() => {
    onFormCalculation();
  }, [isFormChanged]);

  useEffect(() => {
    accountService.accountProfitAndIncomeList().then((res) => {
      setAccountList(res.data.response_data);
    });
  }, []);

  useEffect(() => {
    commonService.dayList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setDayList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    // ProgrammeService.coachListWithRatioRate().then((res) => {
    //     setCoachList(res.data.response_data);
    // });
    getCoachList();
  }, [tapGroup]);

  useEffect(() => {
    // const total_paid_amount = paymentPaidList.reduce(
    //     (a, v) => (a = a + parseFloat(v.amount)),
    //     0
    // );

    // setTotalPaidAmount(
    //     parseFloat(commonUtility.sanitizeValue(total_paid_amount).toFixed(2))
    // );
    // form.setFieldsValue({
    //     payment_amount: total_paid_amount.toFixed(2),
    // });

    const total_paid_amount = paymentPaidList.reduce(
      (a, v) => (a = a + parseFloat(v.amount)),
      0
    );
    const total_bank_charges = paymentPaidList.reduce(
      (a, v) => (a = a + parseFloat(v.bank_charges)),
      0
    );

    setTotalBankCharges(
      parseFloat(commonUtility.sanitizeValue(total_bank_charges)).toFixed(2)
    );
    setTotalPaidAmount(
      parseFloat(commonUtility.sanitizeValue(total_paid_amount)).toFixed(2)
    );

    form.setFieldsValue({
      payment_amount: total_paid_amount.toFixed(2),
      total_bank_charges: total_bank_charges,
    });

    //  setRemainingAmount(totalPayableAmount -  totalPaidAmount)
  }, [paymentPaidList, receiptID, paymentID]);

  /***************************************ADD MODE***************************/
  /***************************************ADD MODE***************************/
  /***************************************ADD MODE***************************/
  useEffect(() => {
    setEnrollmentID(params.enrollmentid);
    setReceiptID(params.receiptid);
    setPaymentID(params.paymentid);
  }, []);

  /*
        useEffect(() => {
          onSelectMember(memberID);
          console.log(memberID);
        }, [programmeID, memberID]);
      
        useEffect(() => {
          const data = {
            formdata: { programme_id: programmeID },
          };
          memberService.memberListByProgramme(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
              setMemberList(res.data.response_data);
            }
          });
        }, [programmeID, memberID]);
        */

  /** TAP Additional */

  /**
   * This block commented on 10/11/2023
   * Because on Edit Member selection list is disable for now
   *
  useEffect(() => {
    setMemberList([]);
    memberListRef.current = [];
    if (enrollmentID > 0) {
      memberService.tapMemberListAllWithActiveInactive().then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setMemberList(res.data.response_data);
          memberListRef.current = res.data.response_data;
        }
      });
    } else {
      memberService.allMemberTapList().then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setMemberList(res.data.response_data);
          memberListRef.current = res.data.response_data;
        }
      });
    }
  }, [enrollmentID]);
  */


  useEffect(() => {
    setMemberList([]);

    memberService.allMemberTapList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        //  console.log('res.data.response_data', res.data.response_data);
        setMemberList(res.data.response_data);
      }
    });
  }, []);


  useEffect(() => {
    populateMemberAdjustment();
  }, [memberID]);

  /** ****************************************************************************
   * ******************************* Edit Mode ***********************************
   * *****************************************************************************
   */

  /**
   * Setting Booking Info Data
   */
  useEffect(() => {
    if (enrollmentID > 0 && receiptID > 0) {
      const data = {
        formdata: {
          enrollment_id: enrollmentID,
        },
      };
      enrollmentService.JCPenrollmentDatabyID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const enrollment_data = res.data.response_data[0];
          console.log('enrollment_data', enrollment_data);

          setProgrammeID(enrollment_data.programme_id);
          setProgrammeGroupID(enrollment_data.group_id);
          setMemberID(enrollment_data.member_id);
          setBookingValidStartDate(null);
          setBookingValidEndDate(null);

          form.setFieldsValue({
            mode: "EDIT",
            enrollment_id: enrollmentID,
            //member_search: enrollment_data.member_id,
            member_search: enrollment_data.enrollment_id,
            member_id: enrollment_data.member_id,
            member_name: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
            member_primary_mobile: enrollment_data.primary_mobile,
            member_father_name:
              enrollment_data.father_name != null &&
                enrollment_data.father_name != ""
                ? enrollment_data.father_name
                : "",
            date_of_birth: enrollment_data.date_of_birth,
            programme_id: enrollment_data.programme_id,
            group_id: enrollment_data.group_id,
            join_date:
              enrollment_data.enrollment_date != null &&
                enrollment_data.enrollment_date != ""
                ? moment(enrollment_data.enrollment_date, DATE_FORMAT_DMY_SLASH)
                : "",
            date_of_join: enrollment_data.enrollment_date,
            enrollment_date: enrollment_data.enrollment_start_date,
            enrollment_start_date: enrollment_data.enrollment_start_date,
            enrollment_end_date: enrollment_data.enrollment_end_date,
            trainee_member: enrollment_data.member_trainee,
          });


          setMemberOrTrainer(enrollment_data.member_trainee);


          setBookingValidStartDate(enrollment_data.enrollment_start_date);
          setBookingValidEndDate(enrollment_data.enrollment_end_date);

          setMemberDisplayInfo({
            memberName: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
            memberPrimaryMobile: enrollment_data.primary_mobile,
            memberFatherName:
              enrollment_data.father_name != null &&
                enrollment_data.father_name != ""
                ? enrollment_data.father_name
                : "",
            memberDOB: enrollment_data.date_of_birth,
            profilePic: enrollment_data.profile_picture,
          });

          setMemberDisplayOtherInfo({
            joinDate: enrollment_data.enrollment_date,
            validity: `${enrollment_data.enrollment_start_date} to ${enrollment_data.enrollment_end_date}`,
          });

          // console.log('memberList',memberList);
          // const filteredItems = memberListRef.current.filter(item => item.member_id != enrollment_data.member_id);
          // console.log('filteredItems',filteredItems);
          //setPlayWithMemberList(filteredItems);
          //console.log("memberListRef",memberListRef.current)
          setIsPaymentModeDisabled(true);
          generatePlayWithMemberShipList(
            enrollment_data.member_id,
            enrollment_data.enrollment_start_date,
            enrollment_data.enrollment_end_date
          );
        }
      });
    }
  }, [enrollmentID]);

  /**
   * Setting Receipt Data
   * Setting Schedule Generation Data
   * Setting Payment Data
   */
  useEffect(() => {
    if (receiptID > 0) {
      const data = {
        formdata: {
          receipt_id: receiptID,
        },
      };

      const schedule_data = {
        formdata: {
          enrollment_id: enrollmentID,
          receipt_id: receiptID,
        },
      };
      ProgrammeService.tapBookingDetailList(schedule_data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          let scheduleList = res.data.response_data;
          let responseBookingCancelData = res.data.response_booking_cancel_data;

          if (responseBookingCancelData.length > 0) {
            setIsSaveEnableBooking(true);
          } else {
            setIsSaveEnableBooking(false);
          }

          setBookingTimeSlotList([]);
          let bookingschedule = [];
          scheduleList.map((schedule) => {
            /*
                                    let isWithText = "";
                                    if(schedule.is_with_coach!="" && schedule.is_with_coach == "Y") {
                                        isWithText = "With Coach";
                                    }
            
                                    if(schedule.is_with_coach!="" && schedule.is_with_coach != "Y") {
                                        isWithText = "Without Coach";
                                    }
                                    */

            bookingschedule.push({
              unique_id: commonUtility.randomID(),
              day_id: schedule.day_id,
              day_code: schedule.day_name,
              day_name: schedule.day_name,
              time_slot_id: schedule.time_slot_id,
              start_time: schedule.from_time,
              end_time: schedule.to_time,
              time_slot: schedule.time_slot,
              rate_per_slot: schedule.rate_per_slot,
              //no_of_holidays: booking_data.no_of_holidays,
              no_of_days: schedule.no_of_days,
              total_value: schedule.total_amount,

              //trainee_member : schedule.rate_for,
              available_dates: schedule.temp_available_dates.split(","),
              holiday_list: schedule.holiday_list,
              holidayDates: schedule.holidayDates,
              no_of_holiday: schedule.no_of_holiday,
              // tap_group: schedule.tap_group,
              // tap_group_txt: schedule.tap_group == "TAPM" ? 'TAP Morning' : 'Special Coaching',
              is_with_coach: schedule.is_with_coach,
              is_with_coach_txt: schedule.is_with_coach_txt,
              coach_detail_txt:
                schedule.rate_details_id > 0
                  ? schedule?.coach_name +
                  " - " +
                  schedule?.ratio_name +
                  " - " +
                  schedule?.time_tag
                  : "",
              coach_rate_detail_id: schedule.rate_details_id,
              coach_master_id: schedule.coach_master_id,
              coaching_amount_per_slot: schedule.coaching_amount_per_slot,
              bta_amount_per_slot: schedule.bta_amount_per_slot,
              coach_amount_slot: schedule.coach_amount_slot,
            });

            /*
                                    setBookingTimeSlotList([...bookingTimeSlotList, {
                                        unique_id: commonUtility.randomID(),
                                        day_id: schedule.day_id,
                                        day_code: schedule.day_name,
                                        day_name: schedule.day_name,
                                        time_slot_id: schedule.time_slot_id,
                                        start_time: schedule.from_time,
                                        end_time: schedule.to_time,
                                        time_slot: schedule.time_slot,
                                        rate_per_slot: schedule.rate_per_slot,
                                        //no_of_holidays: booking_data.no_of_holidays,
                                        no_of_days: schedule.no_of_days,
                                        total_value: schedule.total_amount,
            
                                        available_dates:schedule.temp_available_dates, // str to array
                                        tap_group: schedule.tap_group,
                                        tap_group_txt: schedule.tap_group == "TAPM" ? 'TAP Morning' : 'Special Coaching',
                                        is_with_coach: schedule.is_with_coach,
                                        is_with_coach_txt: 'ssa',
                                        coach_detail_txt: schedule?.coach_name + " - " + schedule?.ratio_name + " - " + schedule?.time_tag ,
                                        coach_rate_detail_id: schedule.coach_rate_detail_id,
                                        coach_master_id: schedule.coach_master_id,
                                    }]);
            
                                    */
          });

          setBookingTimeSlotList(bookingschedule);
        }
      });

      //Receipt Detail Data :

      enrollmentService.componentDetailsAgainstReceiptTap(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setTotalAmount(0);
          setTotalDiscountAmount(0);
          setTotalTaxableAmount(0);
          setTotalCGSTAmount(0);
          setTotalSGSTAmount(0);
          setTotalNetAmount(0);
          setTotalPayableAmount(0);

          const receipt_data = res.data.response_data[0];

          form.setFieldsValue({
            mode: "EDIT",
            taxable_amount: receipt_data.taxable_amount,
            cgst_id: receipt_data.cgst_id,
            cgst_amount: receipt_data.cgst_amount,
            cgst_rate: receipt_data.cgst_rate,
            sgst_id: receipt_data.sgst_id,
            sgst_amount: receipt_data.sgst_amount,
            sgst_rate: receipt_data.sgst_rate,
            total_gst_amount: receipt_data.total_gst_amount,
            net_amount: receipt_data.net_amount,
            total_payable_amount: receipt_data.taxable_amount,
            discount: receipt_data.discount,
            cr_ac_id: receipt_data.cr_ac_id,
            is_waiver: receipt_data.is_waiver,
          });

          setTotalAmount(receipt_data.amount.toFixed(2));
          setTotalTaxableAmount(receipt_data.taxable_amount.toFixed(2));
          setTotalDiscountAmount(receipt_data.discount.toFixed(2));
          setTotalCGSTAmount(receipt_data.cgst_amount.toFixed(2));
          setTotalSGSTAmount(receipt_data.sgst_amount.toFixed(2));

          const total_net_amount =
            receipt_data.taxable_amount +
            receipt_data.cgst_amount +
            receipt_data.sgst_amount;

          setTotalNetAmount(total_net_amount.toFixed(2));
          setTotalPayableAmount(receipt_data.net_amount.toFixed(2));
        }
      });

      enrollmentService.JCPReceiptDatabyID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const receipt_data = res.data.response_data[0];

          let copartner_id = [];
          if (
            commonUtility.sanitizeObject(receipt_data.co_partner_ids) &&
            receipt_data.co_partner_ids != 0
          ) {
            copartner_id = receipt_data.co_partner_ids.split(",").map(Number);
          }

          //let copartner_id = receipt_data.co_partner_ids.split(',').map(Number);

          let tapGroupValue = receipt_data.tap_group;
          if (tapGroupValue == "TAPM") {
            setIsSpecialCoaching(false);
            form.setFieldsValue({
              is_with_coach: "",
              rate_per_slot: 0,
              //time_slot_id:'',
              time_slot_id: [],
              day_id: "",
              cr_ac_id: TAP_BOOKING_CREDIT_ACCOUNT_ID,
            });
            setTapGroupSelected(true);
          } else if (tapGroupValue == "TAPSC") {
            setIsSpecialCoaching(true);
            form.setFieldsValue({
              coach_master_id: "",
              rate_per_slot: 0,
              time_slot_id: [],
              day_id: "",
              cr_ac_id: TAP_BOOKING_SPECIAL_COACHING_CREDIT_ACCOUNT_ID,
            });
            setTapGroupSelected(true);
          }

          const trainee_member = memberOrTrainer;



          form.setFieldsValue({
            mode: "EDIT",
            receipt_id: receipt_data.receipt_id,
            receipt_no: receipt_data.receipt_no,
            from_date: receipt_data.tap_start_date,
            booking_start_date: receipt_data.tap_start_date
              ? moment(receipt_data.tap_start_date, DATE_FORMAT_DMY_SLASH)
              : "",
            to_date: receipt_data.tap_end_date,
            booking_end_date: receipt_data.tap_end_date
              ? moment(receipt_data.tap_end_date, DATE_FORMAT_DMY_SLASH)
              : "",
            tap_group: receipt_data.tap_group,
            //trainee_member: receipt_data.tap_group == "TAPSC" ?  trainee_member : "",
            trainee_member: trainee_member,
            is_with_coach: receipt_data.is_with_coach,
            coach_master_id: receipt_data.coach_master_id,
            rate_per_slot: receipt_data.rate_per_slot,
            less_adjustment_days: receipt_data.less_adjustment_days,
            less_adjustment_rate: receipt_data.less_adjustment_rate,
            discount: receipt_data.total_discount,
            adjustment_note: receipt_data.adjustment_note,
            //co_partner_ids:copartner_id.length > 0 ?  copartner_id : null
            co_partner_ids: copartner_id,
          });

          setTapGroup(receipt_data.tap_group);



          //setMemberOrTrainer(receipt_data.member_trainee);
        }
      });

      // Setting up adjustment data
      //populateMemberAdjustment();
      //populatePlayWith();
      //setAddClickEnableCombination(!addClickEnableCombination);
      getCoachList();

    }
  }, [receiptID, memberOrTrainer]);

  /*
      useEffect(() => {
          if (receiptID > 0 && enrollmentID > 0) {
              setBookingTimeSlotList([]);
              const data = {
                  formdata: {
                      enrollment_id: enrollmentID,
                      receipt_id: receiptID,
                  },
              };
  
              ProgrammeService.tapBookingDetailList(data).then((res) => {
                  if (res.data.response_status === SUCCESS_STATUS) {
                      console.log("Response :: ", res.data.response_data)
                      let scheduleList = res.data.response_data;
  
                      scheduleList.map((schedule) => {
  
                          setBookingTimeSlotList([...bookingTimeSlotList, {
                              unique_id: commonUtility.randomID(),
                              day_id: schedule.day_id,
                              day_code: schedule.day_name,
                              day_name: schedule.day_name,
                              time_slot_id: schedule.time_slot_id,
                              start_time: schedule.from_time,
                              end_time: schedule.to_time,
                              time_slot: schedule.time_slot,
                              rate_per_slot: schedule.rate_per_slot,
                              //no_of_holidays: booking_data.no_of_holidays,
                              no_of_days: schedule.no_of_days,
                              total_value: schedule.total_amount,
                          }]);
  
  
                      });
  
                  }
              });
          }
      }, [receiptID, enrollmentID]);
      */

  /**
   * Setting Payment Master Data
   */
  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0 && paymentID > 0) {
      const data = {
        formdata: {
          payment_id: paymentID,
        },
      };
      paymentService.paymentmasterDataByID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setTotalPaidAmount(0);
          setTotalRoundOff(0);

          const payment_data = res.data.response_data[0];
          form.setFieldsValue({
            mode: "EDIT",
            payment_id: payment_data.payment_id,
            payment_date: payment_data.payment_date,
            date_of_payment: payment_data.payment_date
              ? moment(payment_data.payment_date, DATE_FORMAT_DMY_SLASH)
              : "",

            //member_opening_balance: payment_data.short_excess_amount,
            payment_amount: payment_data.payment_amount,
            voucher_id: payment_data.voucher_id,
            // receipt_no: payment_data.payment_no,
            payable_amount: payment_data.total_payble_amount,
            for_month: payment_data.for_month,
            rate_per_month: payment_data.rate_per_month,
            narration: payment_data.narration,
            round_off_amount: payment_data.round_off_amount,
            round_off_account_id: payment_data.round_off_account_id,
          });

          setTotalPaidAmount(payment_data.payment_amount.toFixed(2));
          setTotalRoundOff(payment_data.round_off_amount);
        }
      });

    }
  }, [paymentID]);

  /**
   * Setting Payment Mode List Data
   */
  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0 && paymentID > 0) {
      const data = {
        formdata: {
          payment_id: paymentID,
        },
      };

      paymentService.paymentDetailsDataByID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          let payment_list = res.data.response_data;
          const newData = payment_list.map((details) => {
            return { ...details };
          });
          setPaymentPaidList(newData);
        }
      });
    }
  }, [receiptID, paymentID]);



  useEffect(() => {
    const totalAdjustmentAmt = totalAdjustedAmount(memberAdjustmentList);


    const total_amount = bookingTimeSlotList.reduce(
      (amount, a) => amount + parseFloat(a.total_value),
      0
    );

    const discount =
      parseFloat(form.getFieldValue("discount")) > 0
        ? parseFloat(form.getFieldValue("discount"))
        : 0;

    //const discount =  totalAdjustmentAmt;


    if (bookingTimeSlotList.length > 0) {
      if (form.getFieldValue("mode") == "ADD") {
        let net_payable_amount =
          parseFloat(total_amount) - parseFloat(discount);
        form.setFieldsValue({
          total_schedule_amount: total_amount,
          total_payable_amount: net_payable_amount,
          booking_data: bookingTimeSlotList,
          amount: total_amount,
          //discount: discount,
          //discount: totalAdjustmentAmt,
          taxable_amount: net_payable_amount,
          net_amount: net_payable_amount,
        });
      } else {
        const taxable_amount = parseFloat(total_amount) - parseFloat(discount);
        form.setFieldsValue({
          total_schedule_amount: total_amount,
          total_payable_amount: taxable_amount,
          booking_data: bookingTimeSlotList,
          amount: total_amount,
          //discount: discount,
          //discount: totalAdjustmentAmt,
          taxable_amount: taxable_amount,
          net_amount: taxable_amount,
        });
      }
    } else {
      form.setFieldsValue({
        total_schedule_amount: 0,
        total_payable_amount: 0,
        booking_data: [],
        amount: 0,
        //discount: discount,
        taxable_amount: 0,
        net_amount: 0,
        less_adjustment_days: 0,
        less_adjustment_rate: 0,
      });
    }

    onFormCalculation();
  }, [bookingTimeSlotList]);


  useEffect(() => {
    const total_paid_amount = paymentPaidList.reduce(
      (a, v) => (a = a + parseFloat(v.amount)),
      0
    );
    const total_bank_charges = paymentPaidList.reduce(
      (a, v) => (a = a + parseFloat(v.bank_charges)),
      0
    );

    setTotalBankCharges(
      parseFloat(commonUtility.sanitizeValue(total_bank_charges)).toFixed(2)
    );
    setTotalPaidAmount(
      parseFloat(commonUtility.sanitizeValue(total_paid_amount)).toFixed(2)
    );

    form.setFieldsValue({
      payment_amount: total_paid_amount.toFixed(2),
      total_bank_charges: total_bank_charges,
    });
  }, [paymentPaidList, receiptID, paymentID]);

  useEffect(() => {
    populateTimeSlot();
  }, [programmeGroupID]);

  useEffect(() => {
    setRemainingAmount(
      parseFloat(totalPayableAmount) +
      parseFloat(totalBankCharges) -
      parseFloat(totalPaidAmount)
    );
  }, [totalPayableAmount, totalPaidAmount, totalBankCharges]);




  // const handleChange = (value) => {
  //   if (value.includes('all')) {
  //     console.log('inside');
  //     setSelectedScheduleDates(dateList);
  //   } else {
  //     console.log('else inside');
  //     setSelectedScheduleDates(value);
  //   }
  //   populateTimeSlot();
  // };

  const handleBookingDateChange = (value) => {
    if (value.includes('all') && dateList.length == selectedScheduleDates.length) {
      setSelectedScheduleDates([]);
    }
    else if (value.includes('all')) {
      setSelectedScheduleDates(dateList);
      setIsClickToAddDone(false)
    }
    else {
      setSelectedScheduleDates(value);
      setIsClickToAddDone(false)
    }
    populateTimeSlot();
  };






  const resetFormFields = () => {
    const defaultFormValues = {
      mode: "ADD",
      enrollment_id: 0,
      member_id: 0,
      programme_id: 0,

      voucher_id: 0,
      date_of_join: null,
      enrollment_start_date: null,
      enrollment_end_date: null,
      cr_ac_id: 0,
      student_account_id: MEMBER_ACCOUNT_ID,
      member_opening_balance: 0,
      receipt_id: 0,
      receipt_no: "",
      receipt_date: null,
      is_payment_done: "N",
      no_of_months: 0,
      entry_from: "B", //B = Booking
      round_off_amount: 0,
      round_off_account_id: ROUND_OFF_ACCOUNT_ID,
      total_bank_charges: 0,
      bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
      taxable_amount: 0,

      cgst_id: "",
      cgst_rate: 0,
      cgst_amount: 0,

      sgst_id: "",
      sgst_rate: 0,
      sgst_amount: 0,

      total_gst_amount: 0,

      payment_id: 0,
      total_schedule_amount: 0,
      from_date: "",
      to_date: "",
      tap_group: "",
      is_with_coach: "",
      coach_master_id: "",
      rate_per_slot: 0,
      less_adjustment_days: 0,
      less_adjustment_rate: 0,
      discount: 0,
      total_payable_amount: 0,
      booking_data: [],
    };
  };

  const handleDiscountChange = (e) => {
    const value = e.target.value;
    const isDiscountEntered = value.trim() !== '' && value.trim() !== '0';

    // Update the state to determine if the discount note should be required
    setIsDiscountEntered(isDiscountEntered);

    // Set the discount_note to an empty string if no discount is entered
    if (!isDiscountEntered) {
      form.setFieldsValue({ adjustment_note: '' });
    }

    // Recalculate the adjusted and taxable amounts
    calculateAdjustedAndTaxableAmount(value);
  };


  /******************************
   * End of TAP JS Code
   * ****************************
   */

  const latestEnrollmentByMember = {};

  memberList.forEach((enrollment) => {
    const memberId = enrollment?.member_id;
    const enrollmentDate = new Date(enrollment?.enrollment_start_date?.split("/")?.reverse()?.join("-"));

    if (
      !latestEnrollmentByMember[memberId] ||
      enrollmentDate > new Date(latestEnrollmentByMember[memberId]?.enrollment_start_date?.split("/")?.reverse()?.join("-"))
    ) {
      latestEnrollmentByMember[memberId] = enrollment;
    }
  });

  useEffect(() => {
    if (receiptID > 0 && receiptID) {
      const data = {
        formdata: {
          receipt_master_id: receiptID,
        },
      };
      ProgrammeService.editMemberNameInBooking(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setEditMemberNameInBooking(res.data.response_data);
        }
      });
    }
  }, [receiptID]);

  const handleDeleteTransaction = () => {
    const data = {
      formdata: {
        receipt_master_id: receiptID,
        payment_id: paymentID,
      },
    };
    ProgrammeService.deleteBookingTransaction(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        message.success("Transaction deleted successfully");
        changeLocation("/tap/bookinglist");
      } else {
        message.error("Failed to delete transaction");
      }
    });
  };

  const onDeleteTransaction = () => {
    confirm({
      title: 'Delete Transaction',
      icon: <ExclamationCircleFilled />,
      content: 'Are you sure you want to delete this transaction? This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleDeleteTransaction();
      },
      onCancel() {
        // Do nothing
      },
    });
  };

  return (
    <div className="form-input-style">
      <Row
        className="login-first-step-row"
        style={{ background: "transparent" }}
      >
        <Col
          className="form-format-type1 enrollment-form tap-registration"
          xs={24}
          xl={24}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onTapBookingSave}
            autoComplete="off"
            initialValues={defaultFormValues}
            onFieldsChange={(event) => onFormCalculation()}
            onKeyUp={(event) => onFormCalculation()}
            onBlur={(event) => onFormCalculation()}
          >
            <Collapse
              bordered={false}
              defaultActiveKey={[
                "programme_jcp",
                "schedule_tap",
                "adjustment_panel",
                "receipt_jcp",
              ]}
              // onChange={onChangeCollapse}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header={
                  <>
                    <h4>Booking Info</h4>
                  </>
                }
                key="programme_jcp"
                className="mainPanel"
              >
                <Row gutter={20}>
                  <Col xs={24} xl={12}>
                    <Row gutter={20}>
                      <Col className="gutter-row" xs={24} xl={24}>
                        <Form.Item
                          name="member_search"
                          label="Search (Name | Mobile no | Father Name)"
                          rules={[
                            {
                              required: true,
                              message: "Select Member / Student",
                            },
                          ]}
                        >
                          <Select
                            disabled={receiptID > 0 ? true : false}
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              //option.children.includes(input)                             
                              Object.values(option.children).join('').replace(/\s/g, '').toLowerCase()
                                .includes(input.replace(/(\s+|to)/g, '').toLowerCase())
                            }
                            // filterSort={(optionA, optionB) =>
                            //   optionA.children
                            //     .toLowerCase()
                            //     .localeCompare(optionB.children.toLowerCase())
                            // }
                            onSelect={(value, event) =>
                              onSelectMember(value, event)
                            }
                          >
                            {memberList.length > 0
                              ? memberList.map((member_list) => {
                                const isLatestForMember =
                                  latestEnrollmentByMember[member_list.member_id]?.enrollment_id === member_list.enrollment_id;
                                return (
                                  <Option
                                    key={`${member_list.member_id}_${member_list?.enrollment_id > 0 ? member_list?.enrollment_id : 0}_${Math.floor(Math.random() * 999999)}`}
                                    value={member_list.enrollment_id}
                                    member_id={member_list.member_id}
                                    style={{ fontSize: 'smaller', fontWeight: isLatestForMember ? 'bold' : 'normal', backgroundColor: isLatestForMember ? '#b7e4c7' : 'white', borderBottom: '1px solid #e8e8e8', color: isLatestForMember ? 'red' : 'black' }}
                                  >
                                    {`${member_list.member_fname} ${member_list.member_lname
                                      } | ${member_list.primary_mobile} | ${member_list.enrollment_start_date} to ${member_list.enrollment_end_date}`}
                                  </Option>
                                )
                              })
                              : ""}
                          </Select>
                        </Form.Item>
                        <Form.Item name="enrollment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="mode" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="member_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="programme_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="voucher_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="entry_from" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="student_account_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="payment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="receipt_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        {/* <Form.Item name="total_schedule_amount" hidden={false} label="Total Schedule Amount">
                                                    <Input type="text" />
                                                </Form.Item> */}
                        <Form.Item
                          name="payable_amount"
                          hidden={true}
                          label="payable_amount"
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="round_off_amount" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="round_off_account_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          label="Bank Charge"
                          name="total_bank_charges"
                          hidden={true}
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          label="Bank Charge"
                          name="bank_charges_account_id"
                          hidden={true}
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          name="payment_amount"
                          hidden={true}
                          label="payment_amount"
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="amount" hidden={true} label="amount">
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="booking_data" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={24}>
                        <Form.Item
                          name="co_partner_ids"
                          label="Play with Members"
                        >
                          {/* <Select className="text-left" defaultValue="0"> */}

                          <Select
                            showSearch
                            mode="multiple"
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              // option.children.includes(input)
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            placement="bottomLeft"
                            allowClear={true}
                            onSelect={(value, event) => {
                              populateMemberAdjustment();
                            }}
                            onClear={() => {
                              console.log('clear', 'clearn on');
                              setSelectedRowKeys([])
                              setMemberAdjustmentList([]);
                            }}
                          >
                            {playWithMemberList.length > 0
                              ? playWithMemberList.map((play_with_member) => (
                                <Option
                                  key={play_with_member.member_id}
                                  value={play_with_member.member_id}
                                >
                                  {`${play_with_member.member_fname} ${play_with_member.member_lname
                                    } | ${play_with_member.primary_mobile}  ${play_with_member.father_name != null
                                      ? play_with_member.father_name
                                      : ""
                                    }`}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row" xs={24} xl={12}>
                        <Form.Item
                          name="booking_start_date"
                          label="Booking from"
                          rules={[
                            {
                              required: true,
                              message: "Booking From is required",
                            },
                          ]}
                        >
                          <DatePicker
                            format={DATE_FORMAT_DMY_SLASH}
                            onChange={onBookingStartDateChange}
                            style={{ width: "100%" }}
                            inputReadOnly={true}
                            /*
                            disabledDate={(current) => {
                                if (commonUtility.sanitizeObject(bookingValidEndDate) != "" && commonUtility.sanitizeObject(bookingValidEndDate) != "" && commonUtility.sanitizeObject(lastBookingValidity) == "") {
                                 
                                    return current < moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidStartDate, "-")), "YYYY-MM-DD") || current > moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidEndDate, "-")), "YYYY-MM-DD").add(1, 'day');
                                }
                                else if (commonUtility.sanitizeObject(bookingValidEndDate) != "" && commonUtility.sanitizeObject(bookingValidEndDate) != "" && commonUtility.sanitizeObject(lastBookingValidity) != "") {
                                   return current < moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidStartDate, "-")), "YYYY-MM-DD").add(1, 'day') || current > moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidEndDate, "-")), "YYYY-MM-DD").add(1, 'day');
                                }
                                else {
                                    return current.isBefore(moment().subtract(1, "day"));
                                }
                            }}
                            */
                            disabledDate={(current) => {
                              if (
                                commonUtility.sanitizeObject(
                                  bookingValidEndDate
                                ) != "" &&
                                commonUtility.sanitizeObject(
                                  bookingValidEndDate
                                ) != ""
                              ) {
                                return (
                                  current <
                                  moment(
                                    new Date(
                                      commonUtility.dateFormatYYYYMMDD(
                                        bookingValidStartDate,
                                        "-"
                                      )
                                    ),
                                    "YYYY-MM-DD"
                                  ).subtract(1, "day") ||
                                  current >
                                  moment(
                                    new Date(
                                      commonUtility.dateFormatYYYYMMDD(
                                        bookingValidEndDate,
                                        "-"
                                      )
                                    ),
                                    "YYYY-MM-DD"
                                  ).add(1, "day")
                                );
                              } else {
                                return current.isBefore(
                                  moment().subtract(1, "day")
                                );
                              }
                            }}

                          />
                        </Form.Item>
                        <Form.Item name="from_date" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      {/* Bstart : {bookingValidStartDate}
                                            Bend : {bookingValidEndDate} */}
                      <Col className="gutter-row" xs={24} xl={12}>
                        <Form.Item
                          name="booking_end_date"
                          label="Booking To"
                          rules={[
                            {
                              required: true,
                              message: "Booking to is required",
                            },
                          ]}
                        >
                          <DatePicker
                            format={DATE_FORMAT_DMY_SLASH}
                            onChange={onBookingEndDateChange}
                            style={{ width: "100%" }}
                            inputReadOnly={true}
                            /*
                                                                                    disabledDate={(current) => {
                                                                                        if (commonUtility.sanitizeObject(bookingValidEndDate) != "" && commonUtility.sanitizeObject(bookingValidEndDate) != "") {
                                                                                         
                                                                                            return current < moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidStartDate, "-")), "YYYY-MM-DD") || current > moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidEndDate, "-")), "YYYY-MM-DD").add(1, 'day');
                                                                                        }
                                                                                        else if (commonUtility.sanitizeObject(bookingValidEndDate) != "" && commonUtility.sanitizeObject(bookingValidEndDate) != "") {
                                                                                           return current < moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidStartDate, "-")), "YYYY-MM-DD").add(1, 'day') || current > moment(new Date(commonUtility.dateFormatYYYYMMDD(bookingValidEndDate, "-")), "YYYY-MM-DD").add(1, 'day');
                                                                                        }
                                                                                        else {
                                                                                            return current.isBefore(moment().subtract(1, "day"));
                                                                                        }
                            
                                                                                    }}
                                                                                    */

                            disabledDate={(current) => {
                              if (
                                commonUtility.sanitizeObject(
                                  bookingValidEndDate
                                ) != "" &&
                                commonUtility.sanitizeObject(
                                  bookingValidEndDate
                                ) != ""
                              ) {
                                return (
                                  current <
                                  moment(
                                    new Date(
                                      commonUtility.dateFormatYYYYMMDD(
                                        bookingValidStartDate,
                                        "-"
                                      )
                                    ),
                                    "YYYY-MM-DD"
                                  ).subtract(1, "day") ||
                                  current >
                                  moment(
                                    new Date(
                                      commonUtility.dateFormatYYYYMMDD(
                                        bookingValidEndDate,
                                        "-"
                                      )
                                    ),
                                    "YYYY-MM-DD"
                                  ).add(1, "day")
                                );
                              } else {
                                return current.isBefore(
                                  moment().subtract(1, "day")
                                );
                              }
                            }}
                          />
                        </Form.Item>
                        <Form.Item name="to_date" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                      {/* <Col xs={24} xl={24} hidden={lastBookingValidity == ""}>
                        <p
                          style={{
                            fontSize: "0.8rem",
                            fontWeight: "600",
                            color: "#0f9cd2",
                          }}
                        >
                          Last Booked Data : {lastBookingValidity}{" "}
                        </p>
                      </Col> */}

                      {/* 
                                            <Col xs={24} xl={12} hidden={true}>
                                                <Form.Item
                                                    name="enrollment_start_date"
                                                    label="Programme Valid From"
                                                >
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col> */}

                      {/* <Col xs={24} xl={12} hidden={true}>
                                                <Form.Item
                                                    name="enrollment_end_date"
                                                    label="Programme Valid To"
                                                >
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col> */}

                      {/* <Col xs={24} xl={12}>
                                                <Form.Item name="rate_per_month" label="Rate/Month">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={12}>
                                                <Form.Item name="taxable_amount" label="Total Taxable">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col> */}

                      {/* <Col xs={24} xl={12}>
                                                <Form.Item name="tap_group" label="TAP Morning / Special Coaching" >
                                                    <Select className="text-left" allowClear={true} onChange={(event) => onTapSpecialChange(event)}>
                                                        <Option value="TAPM"> TAP Morning</Option>
                                                        <Option value="TAPSP"> Special Coaching</Option>
                                                    </Select>
                                                </Form.Item>

                                            </Col> */}

                      {/* <Col xs={24} xl={12} hidden={isSpecialCoaching} >
                                                <Form.Item name="is_with_coach" label="With Coach / Without Coach" >
                                                    <Select className="text-left" allowClear={true} onChange={(event) => onChangeWithCoachWithoutCoach(event)} >
                                                        <Option value="Y"> With Coach</Option>
                                                        <Option value="N"> Without Coach</Option>
                                                    </Select>
                                                </Form.Item>

                                            </Col> */}

                      {/* <Col xs={24} xl={12} hidden={!isSpecialCoaching}>
                                                <Form.Item name="coach_master_id" label="Coach List">
                                                    <Select className="text-left" allowClear={true} onChange={(value, event) => onChangeCoach(value, event)} >
                                                        {coachList.length > 0
                                                            ? coachList.map((coach_list) => (
                                                                <Option
                                                                    key={coach_list.coach_id}
                                                                    coaching_fee={coach_list.coaching_fee}
                                                                    value={coach_list.coach_id}
                                                                >
                                                                    {coach_list.coach_name}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>
                                            </Col> */}

                      {/* <Col xs={24} xl={12}>
                                                <Form.Item name="rate_per_slot" label="Rate">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col> */}

                      <Col xs={4} xl={12}>
                        <Form.Item
                          name="tap_group"
                          // label={<span className={clickToAddFormErr.type ? 'required-label' : 'normal-label'}>{clickToAddFormErr.type ? 'Type*' : 'Type*'}</span>}
                          label="Type"
                        >
                          <Select
                            className="text-left"
                            allowClear={true}
                            onChange={(event, val) =>
                              onTapSpecialChange(event, val)
                            }
                          >
                            <Option value="TAPM" valueText="Adult Coaching">
                              Adult Coaching
                            </Option>
                            <Option value="TAPSC" valueText="Special Coaching">
                              {" "}
                              Special Coaching
                            </Option>
                          </Select>
                        </Form.Item>

                        <Form.Item name="tap_group_txt" label="" hidden={true}>
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={12}>
                        <Form.Item name="is_waiver" label="Apply Waive">
                          <Select
                            className="text-left"
                            allowClear={false}
                            onChange={(value, event) =>
                              onWaveChange(value, event)
                            }
                          >
                            <Option value="N" selected>
                              No
                            </Option>
                            <Option value="Y">Yes</Option>
                          </Select>
                          {/* {openWaivePopUp && renderPopconfirm()} */}

                          {/* <Select className="text-left" allowClear={false} 
                                                    onChange={(value, event) => onWaveChange(value, event)}
                                                    >
                                                        <Option value="N" selected>No</Option>
                                                        <Option value="Y">Yes</Option>
                                                    </Select> */}
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={12}>
                        <Form.Item
                          name="cr_ac_id"
                          label="Account to be Credited"
                          rules={[
                            {
                              required: true,
                              message: "Account is required",
                            },
                          ]}
                        >
                          {/* <Select className="text-left" defaultValue="0"> */}

                          <Select
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              // option.children.includes(input)
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            placement="bottomLeft"
                            allowClear={true}
                            disabled={true}
                          >
                            {accountList.length > 0
                              ? accountList.map((account_data) => (
                                <Option
                                  key={account_data.id}
                                  value={account_data.id}
                                >
                                  {account_data.account_name}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={4} xl={12}>
                        <Form.Item name="trainee_member" label="Trainee/Member">
                          <Select
                            className="text-left"
                            allowClear={true}
                            //onChange={(event, val) => OnTraineeMemberChange(event, val)}
                            disabled={true}
                          >
                            <Option value="TRAINEE" valueText="TRAINEE">
                              Trainee
                            </Option>
                            <Option value="MEMBER" valueText="Member">
                              Member
                            </Option>
                          </Select>
                        </Form.Item>

                        {/* <Form.Item name="tap_group_txt" label="" hidden={true} >
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item> */}
                      </Col>
                      <Col xs={4} xl={24}>
                        <Button
                          htmlType="button"
                          type="primary"
                          danger
                          className="custom-button-red"
                          onClick={onDeleteTransaction}
                          shape="rounded"
                          style={{ display: editMemberNameInBooking == 'Y' ? 'block' : 'none' }}
                        >
                          Delete this Transaction <DeleteOutlined />
                        </Button>
                      </Col>
                    </Row>
                  </Col>

                  {/** end of column */}
                  <Col xs={24} xl={12}>
                    <Row gutter={20}>
                      <Col xs={24} xl={24}>
                        <StudentCardInfo
                          memberDisplayInfo={memberDisplayInfo}
                          memberDisplayOtherInfo={memberDisplayOtherInfo}
                        />
                      </Col>

                      {/** Booking Validity Last Booked Data : 01/09/2023 to 30/09/2023(Special Coaching) */}
                      <Col xs={24} xl={24}>

                      </Col>
                      <Col xs={24} xl={24} hidden={lastBookingValidity.length == 0}>
                        <div style={{
                          fontSize: "0.8rem",
                          fontWeight: "600",
                          color: "#0f9cd2",
                          margin: 0,
                          height: 180,
                          maxHeight: 180,
                          overflowY: 'scroll',
                          marginTop: 4,
                          scrollbarWidth: 'thin',
                          scrollbarColor: '#0f9cd2 #f1f1f1'
                        }}

                        >
                          <table style={{ width: '100%' }} cellSpacing={2} cellPadding={4}>
                            <tbody>
                              {
                                lastBookingValidity.map((item, index) => (
                                  <tr key={`member_receipt_detail_${Math.random(10, 1000000)}`}>
                                    <td style={{ width: '5%' }}>#{index + 1}</td>
                                    <td style={{ width: '85%' }}>{`Booked Info ${item.tap_start_date} to ${item.tap_end_date} (${item.tap_group == "TAPM" ? "Adult Coaching" : "Special Coaching"})`}</td>
                                    <td><a href={`/tap/booking/${item.enrollment_id}/${item.receipt_id}/${item.payment_id}`} target="_blank" rel="noopener noreferrer">
                                      <Button htmlType="button" type="ghost" size="small" shape="" danger ><EditOutlined /></Button>
                                    </a></td>
                                    <td style={{ width: '10%' }}>
                                      <a href={`http://btaportal.in/custom/report/tap/printpdf/${item.enrollment_id}/${item.receipt_id}/${item.payment_id}`} target="_blank" rel="noopener noreferrer">
                                        <Button htmlType="button" type="ghost" size="small" shape="" primary ><PrinterOutlined /></Button>
                                      </a>
                                    </td>
                                  </tr>



                                ))

                              }
                            </tbody>
                          </table>
                        </div>
                      </Col>


                    </Row>
                  </Col>
                  <Col xs={24} xl={12}>
                    {isAlreadyMemberEnrolled ? (
                      <>
                        <Form.Item name="" label=" ">
                          <Alert
                            message={alreadyMemberEnrolledMessage}
                            type="error"
                          />
                        </Form.Item>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Panel>

              <Panel
                header={
                  <>
                    <h4>Schedule Generation</h4>
                  </>
                }
                key="schedule_tap"
                className="mainPanel"
              >
                {/* <TapTimeSlotView mode={form.getFieldValue("mode")} timeSlotListData={timeSlotList} /> */}

                <Row gutter={20}>
                  {/* <Col xs={4} xl={4}>

                                        <Form.Item name="tap_group" label={<span className={clickToAddFormErr.type ? 'required-label' : 'normal-label'}>{clickToAddFormErr.type ? 'Type*' : 'Type*'}</span>} >
                                            <Select className="text-left" allowClear={true} onChange={(event, val) => onTapSpecialChange(event, val)}>
                                                <Option value="TAPM" valueText="TAP Morning"> TAP Morning</Option>
                                                <Option value="TAPSC" valueText="Special Coaching"> Special Coaching</Option>
                                            </Select>
                                        </Form.Item>

                                        <Form.Item name="tap_group_txt" label="" hidden={true} >
                                            <Input placeholder="" readOnly={true} />
                                        </Form.Item>



                                    </Col> */}

                  {/**
                                     * 
                                    
                                    <Col xs={4} xl={4} hidden={true}>
                                        <Form.Item name="trainee_member" 
                                            label="Trainee/Member" 
                                            label={clickToAddFormErr.trainee_member=="" && isSpecialCoaching && clickToAddFormErr.isTrigger ? (<span style={styles.requiredText}>Trainee/Member*</span>) :"Trainee/Member" }
                                        >
                                            <Select className="text-left" allowClear={true} onChange={(event, val) => OnTraineeMemberChange(event, val)}
                                                disabled={!isSpecialCoaching} >
                                                <Option value="TRAINEE" valueText="TRAINEE">Trainee</Option>
                                                <Option value="MEMBER" valueText="Member">Member</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                     * 
                                     */}

                  <Col xs={7} xl={7} hidden={!isSpecialCoaching}>
                    <Form.Item
                      name="coach_rate_detail_id"
                      //label="Coach List*"
                      label={
                        clickToAddFormErr.isTrigger &&
                          clickToAddFormErr.coach_detail_txt == "" &&
                          isSpecialCoaching ? (
                          <span style={styles.requiredText}>Coach List*</span>
                        ) : (
                          "Coach List*"
                        )
                      }
                    >
                      <Select
                        disabled={!tapGroupSelected}
                        className="text-left"
                        allowClear={true}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                          const children = option.children || "";
                          const strongElements = option.props.children.filter(
                            (child) => child && child.type === "strong"
                          );
                          const combinedText = strongElements
                            .map(
                              (strongElement) => strongElement.props.children
                            )
                            .join(" ");
                          return (
                            children
                              .toString()
                              .toLowerCase()
                              .includes(input.toLowerCase()) ||
                            combinedText
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          );
                        }}
                        filterSort={(optionA, optionB) => {
                          const childrenA = optionA.children || "";
                          const childrenB = optionB.children || "";
                          return childrenA
                            .toString()
                            .toLowerCase()
                            .localeCompare(childrenB.toString().toLowerCase());
                        }}
                        onChange={(value, event) => onChangeCoach(value, event)}
                        style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                      >
                        {coachList.length > 0
                          ? coachList.map((coach_list) => (
                            <Option
                              key={coach_list.rate_details_id}
                              coach_name={coach_list.coach_name}
                              ratio_name={coach_list.ratio_name}
                              time_tag={coach_list.time_tag}
                              coach_id={coach_list.coach_id}
                              coaching_fee={coach_list.coaching_fee}
                              value={coach_list.rate_details_id}
                              title={`${coach_list.coach_name} - ${coach_list.ratio_name
                                } - ${coach_list.time_tag} - ${coach_list.rate_for
                                } - ${coach_list.coaching_fee.toFixed(2)}`}
                            >
                              <strong style={{ fontSize: "12px" }}>
                                {coach_list.coach_name}
                              </strong>{" "}
                              <strong
                                style={{
                                  background: "#eee",
                                  padding: "5px",
                                  fontSize: "12px",
                                }}
                              >
                                [{coach_list.ratio_name} -{" "}
                                {coach_list.time_tag} ]
                              </strong>{" "}
                              -{" "}
                              <strong
                                style={{ fontSize: "12px", color: "#1a8811" }}
                              >
                                {coach_list.coaching_fee.toFixed(2)}
                              </strong>
                            </Option>
                          ))
                          : ""}
                      </Select>
                    </Form.Item>

                    <Form.Item name="coach_master_id" label="" hidden={true}>
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                    <Form.Item name="coach_detail_txt" label="" hidden={true}>
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={4} xl={isSpecialCoaching ? 4 : 6}>
                    <Form.Item
                      name="is_with_coach"
                      //label={`With Coach / Without Coach* ${clickToAddFormErr.is_with_coach}`}
                      label={
                        clickToAddFormErr.is_with_coach_txt != "" ? (
                          "Rate Type*"
                        ) : (
                          <span style={styles.requiredText}>Rate Type*</span>
                        )
                      }
                    >
                      <Select
                        className="text-left"
                        allowClear={true}
                        onChange={(event, obj) =>
                          onChangeWithCoachWithoutCoach(event, obj)
                        }
                        disabled={!tapGroupSelected}
                      >
                        {isSpecialCoaching ? (
                          <>
                            <Option value="Y" valueText="With Coach">
                              {" "}
                              With Coach
                            </Option>
                            <Option value="N" valueText="Without Coach">
                              {" "}
                              Without Coach
                            </Option>
                            <Option value="C" valueText="Coach">
                              {" "}
                              Coach
                            </Option>
                          </>
                        ) : (
                          <>
                            <Option value="Y" valueText="With Coach (Morning)">
                              {" "}
                              With Coach (Morning)
                            </Option>
                            <Option
                              value="N"
                              valueText="Without Coach (Morning)"
                            >
                              {" "}
                              Without Coach (Morning)
                            </Option>
                            <Option value="C" valueText="Coach (Morning)">
                              {" "}
                              Coach (Morning)
                            </Option>
                            {memberOrTrainer == "MEMBER" ? (
                              <>
                                <Option value="MD" valueText="Member (Day)">
                                  {" "}
                                  Member (Day)
                                </Option>
                                <Option value="MN" valueText="Member (Night)">
                                  {" "}
                                  Member (Night)
                                </Option>
                              </>
                            ) : (
                              <>
                                <Option value="TD" valueText="Trainee (Day)">
                                  {" "}
                                  Trainee (Day)
                                </Option>
                                <Option value="TN" valueText="Trainee (Night)">
                                  {" "}
                                  Trainee (Night)
                                </Option>
                              </>
                            )}
                          </>
                        )}
                      </Select>
                    </Form.Item>

                    <Form.Item name="is_with_coach_txt" label="" hidden={true}>
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>

                    <Form.Item
                      name="coaching_amount_per_slot"
                      label=""
                      hidden={true}
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>

                    <Form.Item
                      name="bta_amount_per_slot"
                      label=""
                      hidden={true}
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>

                    <Form.Item name="coach_amount_slot" label="" hidden={true}>
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={2} xl={2}>
                    <Form.Item
                      name="rate_per_slot"
                      //label="Rate*"
                      label={
                        clickToAddFormErr.rate_per_slot <= 0 &&
                          clickToAddFormErr.isTrigger ? (
                          <span style={styles.requiredText}>Rate*</span>
                        ) : (
                          "Rate*"
                        )
                      }
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                  <Col xs={3} xl={3}>
                    <Form.Item
                      // label="Day*"
                      name="day_id"
                      label={
                        clickToAddFormErr.isTrigger &&
                          clickToAddFormErr.day_id == "" ? (
                          <span style={styles.requiredText}>Day*</span>
                        ) : (
                          "Day*"
                        )
                      }
                    >
                      <Select
                        className="text-left"
                        defaultValue=""
                        onSelect={() => {
                          setIsClickToAddDone(false);
                          //populateTimeSlot();
                          populateDateByDay();
                        }}
                      >
                        {dayList.length > 0
                          ? dayList.map((day_list) => (
                            <Option
                              key={day_list.day_id}
                              value={day_list.day_id}
                              style={{ fontSize: '12px' }}
                            >
                              {day_list.day_code}
                            </Option>
                          ))
                          : ""}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={3} xl={3}>
                    <Form.Item
                      label={
                        clickToAddFormErr.isTrigger &&
                          clickToAddFormErr.schedule_dates.length == 0 ? (
                          <span style={styles.requiredText}>Dates*</span>
                        ) : (
                          "Dates*"
                        )
                      }
                      name="schedule_dates"
                    >

                      {/* {
                        selectedScheduleDates.map((item)=>{
                          console.log('item',item);
                        })
                      } */}
                      {selectedScheduleDates?.map((item) => { })}
                      <Select
                        className="text-left"
                        value={selectedScheduleDates}

                        // onSelect={(value) => {
                        //   console.log('value S', value);
                        //   console.log('selectedScheduleDates', selectedScheduleDates);
                        //   setIsClickToAddDone(false);
                        //   setSelectedScheduleDates(value);
                        //   populateTimeSlot();
                        // }}

                        mode="multiple"
                        maxTagCount={0}
                        selectControl={true}
                        onChange={handleBookingDateChange}
                      >

                        <Option key="all">
                          {selectedScheduleDates.length == dateList.length ? "Deselct All" : "Select All"}
                        </Option>

                        {dateList.length > 0
                          ? dateList.map((schedule_dates) => (
                            <Option key={schedule_dates} value={schedule_dates} style={{ fontSize: '12px' }}>
                              {schedule_dates}
                            </Option>
                          ))
                          : null}
                      </Select>

                    </Form.Item>
                  </Col>

                  <Col xs={4} xl={4}>
                    <Form.Item
                      label={
                        clickToAddFormErr.isTrigger &&
                          clickToAddFormErr.time_slot_id.length == 0 ? (
                          <span style={styles.requiredText}>Time Slot*</span>
                        ) : (
                          "Time Slot*"
                        )
                      }
                      name="time_slot_id"
                    >
                      <Select
                        className="text-left"
                        value={timeSlotList.length > 0 ? selectedTimeSlots : []}
                        onSelect={(values) => {
                          setIsClickToAddDone(false);
                          setSelectedTimeSlots(values);
                        }}
                        mode="multiple"
                        maxTagCount={0}
                      >
                        {timeSlotList.length > 0
                          ? timeSlotList.map((time_slot) => (
                            <Option
                              key={time_slot.time_slot_id}
                              value={time_slot.time_slot_id}
                              style={{ fontSize: '12px' }}
                            >
                              {time_slot.time_slot}
                            </Option>
                          ))
                          : null}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={1} xl={1}>
                    <Form.Item label=" ">
                      <Button
                        className="custom-button-green"
                        onClick={() => generateTapBookingDays()}
                        icon={<PlusOutlined />}
                        // size="small"
                        disabled={!isClickToAddEnable}
                      >

                      </Button>
                    </Form.Item>
                  </Col>
                </Row>

                <div style={{ marginTop: 10 }}>
                  <TapBookingGeneratedSchedule
                    tapbookingGeneratedSchedule={bookingTimeSlotList}
                    removeBooking={removeBooking}
                  />
                </div>

                <Row gutter={20} style={{ marginTop: 20 }} hidden={true}>
                  <Col xs={24} xl={4}>
                    <Form.Item name="taxable_amount" label="Total Taxable">
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4}>
                    <Form.Item name="cgst_id" label="CGST">
                      <Select
                        className="text-left"
                        allowClear={true}
                      // onChange={(value, event) => onSelectTapRegCGST(event, "DROPDOWN", 0)}
                      ></Select>
                    </Form.Item>

                    <Form.Item name="cgst_rate" hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4}>
                    <Form.Item name="cgst_amount" label="CGST Amt.">
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4}>
                    <Form.Item name="sgst_id" label="SGST">
                      <Select
                        className="text-left"
                        allowClear={true}
                      // onChange={(value, event) => onSelectTapRegSGST(event, "DROPDOWN", 0)}
                      ></Select>
                    </Form.Item>
                    <Form.Item name="sgst_rate" hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4}>
                    <Form.Item name="sgst_amount" label="SGST Amt.">
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>

                    <Form.Item
                      name="total_gst_amount"
                      label="Total GST"
                      hidden={true}
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>

                    <Form.Item
                      name="net_amount"
                      label="Net Amount"
                      hidden={true}
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                </Row>

                {/* <Row gutter={20} style={{ marginTop: 20 }}>
                                    <Col xs={24} xl={5}>

                                        <Form.Item name="" label=" ">
                                            <h3>Less Adjustment</h3>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} xl={4}>
                                        <Form.Item name="less_adjustment_days" label="Days" >
                                            <Input placeholder="" onChange={() => { calculateAdjustedAndTaxableAmount() }} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} xl={4}>
                                        <Form.Item name="less_adjustment_rate" label="Rate">
                                            <Input placeholder="" onChange={() => { calculateAdjustedAndTaxableAmount() }} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} xl={4}>
                                        <Form.Item name="discount" label="Adjusted Amount">
                                            <Input placeholder="" readOnly={true} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} xl={4}>
                                        <Form.Item name="total_payable_amount" label="Total Payable">
                                            <Input placeholder="" readOnly={true} />
                                        </Form.Item>
                                    </Col>

                                </Row> */}
              </Panel>

              <Panel
                header={
                  <>
                    <h4>Adjustment</h4>
                  </>
                }
                key="adjustment_panel"
                className="mainPanel"
                style={
                  {
                    //opacity : `${totalPayableAmount > memberAdjustmentAllAmountFromList ? 1 : 0.5}`,
                    //pointerEvents : `${totalPayableAmount > memberAdjustmentAllAmountFromList ? 'auto' : 'none'}`,
                  }
                }
              >
                {/* <TapMemberAdjustment memberAdjustmentList={memberAdjustmentList} tapForm = {form}  /> */}

                {memberAdjustmentList.length > 0 ? (
                  <>
                    {/* <Table key={tapbookingGeneratedSchedule.unique_id} columns={columns} dataSource={tapbookingGeneratedSchedule} pagination={false} size="small" /> */}
                    <Table
                      rowSelection={rowSelection}
                      columns={columns}
                      /*
                                                                  rowSelection={rowSelection} 
                                                                  key={memberAdjustmentList.booking_cancle_id} 
                                                                  columns={columns} 
                                                                  */
                      dataSource={memberAdjustmentList}
                      pagination={false}
                      size="small"
                    />

                    {/* 
                    <Button onClick={() => console.log(selectedRows)}>Get Checked Data</Button> */}
                  </>
                ) : (
                  ""
                )}

                <Row gutter={20} style={{ marginTop: 20 }}>
                  <Col xs={24} xl={5}>
                    <Form.Item name="" label=" ">
                      <h3>Less Adjustment</h3>
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} xl={4}>
                                        <Form.Item name="less_adjustment_days" label="Days" >
                                            <Input placeholder="" onChange={() => { calculateAdjustedAndTaxableAmount() }} />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} xl={4}>
                                        <Form.Item name="less_adjustment_rate" label="Rate">
                                            <Input placeholder="" onChange={() => { calculateAdjustedAndTaxableAmount() }} />
                                        </Form.Item>
                                    </Col> */}

                  <Col xs={24} xl={4}>
                    <Form.Item
                      name="total_schedule_amount"
                      hidden={false}
                      label="Total Amount"
                    >
                      <Input type="text" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4}>
                    <Form.Item name="discount" label="Adjusted Amount">
                      <Input placeholder=""
                        readOnly={false}
                        // onChange={(e) => { calculateAdjustedAndTaxableAmount(e.target.value) }} 
                        onChange={handleDiscountChange}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4}>
                    <Form.Item
                      name="total_payable_amount"
                      label="Total Payable"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                    <Form.Item
                      name="adjustment_data"
                      label="adjustment data"
                      hidden={true}
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={6}>
                    <Form.Item
                      name="adjustment_note"
                      hidden={false}
                      label="Adjustment Note"
                      rules={[
                        {
                          required: isDiscountEntered,
                          message: 'Please fill out the Discount Note field.',
                        },
                      ]}
                    >
                      <TextArea
                        rows={2}
                        style={{ width: '100%' }}
                        disabled={!isDiscountEntered}
                      />
                    </Form.Item>
                  </Col>

                </Row>
              </Panel>

              <Panel
                header={
                  <>
                    <h4>Receipt</h4>
                  </>
                }
                key="receipt_jcp"
                className="mainPanel"
              >
                <Collapse defaultActiveKey={["member_payment_panel"]} ghost>
                  <Panel
                    header="Receipt"
                    key="member_payment_panel"
                    className="member-payment component-panel innerPanel"
                  >
                    {/**
                     * Payments Module
                     */}

                    <PaymentComponent
                      enrollmentForm={form}
                      detailInputKey="component_payment"
                      addPaymentMode={addPaymentMode}
                      paymentPaidList={paymentPaidList}
                      removePayment={removePayment}
                      remainingAmount={remainingAmount}
                      isPaymentModeDisabled={isPaymentModeDisabled}
                    />
                  </Panel>
                </Collapse>

                <div className="totalDetails">
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic>Total Amount : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalAmount} </Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic>Less Amount : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalDiscountAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic>Total Net Amount : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalNetAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic>Round Off : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalRoundOff} </Text>
                    </Col>
                  </Row>


                  {/* -----Previous Code-------
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text
                        italic
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        Total Payable = Amount to pay + Bank Charges(if any) :{" "}
                      </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text
                        strong
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        {totalPayableAmount} + {totalBankCharges}
                      </Text>
                    </Col>
                  </Row> */}


                  {/* New Changes on 02/04/24 =================Start Here*/}

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Amount to pay :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount}</Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Bank Charges(if any) :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalBankCharges}</Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{(Number(totalPayableAmount) + Number(totalBankCharges)).toFixed(2)}</Text>
                    </Col>
                  </Row>
                  {/* New Changes on 02/04/24 =================== Ends Here*/}


                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text
                        italic
                        style={{ fontSize: "18px", color: "#23910c" }}
                      >
                        Total Paid :{" "}
                      </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text style={{ fontSize: "18px", color: "#23910c" }}>
                        {totalPaidAmount}{" "}
                      </Text>
                    </Col>
                  </Row>
                </div>

                {/* <ModalWithMessageAndAction /> */}

                <Row justify="end">
                  <Col>
                    <Form.Item>
                      {/* {isSaveLoaderEnable ? (
                                                <Spin />
                                            ) : (
                                                <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                        disabled={isAlreadyMemberEnrolled}
                                                        className="custom-button-green"
                                                    >
                                                        Save <RightOutlined />
                                                    </Button>
                                                </>
                                            )} */}

                      <Button
                        htmlType="submit"
                        shape="round"
                        disabled={
                          isAlreadyMemberEnrolled || isSaveEnableBooking || isSaveLoaderEnable
                        }
                        className="custom-button-green"
                      >
                        Save <RightOutlined />
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Form>
        </Col>
      </Row>

      {/* <Modal
                title={responseModalTitle}
                centered
                visible={openModal}
                open={openModal}
                // onCancel={handleCancel}
                footer={[
                    <Button key="back" style={{ margin: 1 }}>
                        <PrinterOutlined /> Print
                    </Button>,

                    <Link to={`/tap/bookinglist/`} style={{ margin: 1 }}>
                        <Button htmlType="button" type="primary">
                            {" "}
                            <EyeOutlined /> View List
                        </Button>
                    </Link>,

                    <Link
                        to={`/jcp-tap/membership/`}
                        onClick={() => changeLocation("/tap/membership")}
                        style={{ margin: 1 }}
                    >
                        <Button htmlType="button" type="danger">
                            {" "}
                            <EyeOutlined /> Add More
                        </Button>
                    </Link>,

                ]}
                style={{ width: "100px" }}
                className="responseModal"
            >
                <div style={{ textAlign: "center" }}>
                    <CheckCircleTwoTone
                        twoToneColor="#52c41a"
                        style={{ fontSize: "2.5rem" }}
                    />
                    <h3>{responseModalMessage}</h3>
                </div>
            </Modal> */}

      {/* <ModalWithMessageAndAction responseModalTitle={responseModalTitle} openModal={openModal} listLink='/tap/bookinglist' addmoreLink='/tap/booking' responseModalMessage={responseModalMessage} /> */}

      {responseModal.isOpenModal ? (
        <>
          <ModalWithMessageAndAction
            responseModal={responseModal}
            key={commonUtility.randomID()}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TapBookingView;
